import { useContext } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Decimal } from "decimal.js";
import moment from "moment";
import StoreContext from "./../Componentes/Store/Context";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import { roundNumber, FORMATO_AM_PM, format_miles, MONEY_ROUND, FECHA_MENOR_7DIAS } from "./Util";
import { Box, IconButton } from "@mui/material";
import { dataTipo, imgURLLocalImageIp, isMobileOrTablet } from "./Services";
import { Label, Row, Col } from "reactstrap";
import { COOK_MAN, SEARCH_IMAGE } from "./Image";

export const COLUMNS_BODEGA =
  window.innerWidth <= 611
    ? [
        {
          Cell: ({ cell }) => {
            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b> {cell.row.original.bod_nombre}</b>
                  </span>{" "}
                  <br></br>
                  <span>{cell.row.original.com_alias}</span>
                  <br></br>
                  <span>{cell.row.original.bod_ubicacion}</span>
                  <br></br>
                </Col>
              </Row>
            );
          },
          accessorKey: "bod_nombre",
          header: "BODEGAS",
          grow: true,
          enableEditing: false,
        },
      ]
    : [
        {
          accessorKey: "bod_nombre",
          header: "NOMBRE",
          grow: true,
          Edit: () => null,
          enableEditing: false,
        },
        {
          accessorKey: "com_alias", //normal accessorKey
          header: "SUCURSAL",
          size: 100,
        },
        {
          accessorKey: "bod_ubicacion", //normal accessorKey
          header: "UBICACIÓN",
          size: 200,
          grow: false,
          Edit: () => null,
          enableEditing: false,
        },
      ];
export const COLUMNS_CLIENTES_HISTORIAL = [
  {
    accessorKey: "fac_fecha",
    header: "FECHA",
    size: 90,
    // size: 350,
  },
  {
    accessorKey: "art_upc", //normal accessorKey
    header: "CÓDIGO",
    size: 80,
  },
  {
    accessorKey: "art_descripcion", //normal accessorKey
    header: "ARTÍCULO",
    size: 300,
  },
  {
    accessorKey: "cat_descripcion", //normal accessorKey
    header: "CATEGORIA",
    size: 200,
  },
  {
    accessorKey: "cantidad", //normal accessorKey
    header: "CANTIDAD",
    size: 60,
  },
  {
    accessorKey: "fac_total", //normal accessorKey
    header: "TOTAL",
    size: 60,
  },
];
export function COLUMNS_CLIENTES({ dataRetencion }) {
  return [
    {
      accessorKey: "cli_nombre",
      header: "NOMBRE",
      size: 130,
    },
    {
      accessorKey: "cli_telefono", //normal accessorKey
      header: "TELÉFONO",
      size: 60,
    },
    {
      accessorKey: "cli_ruc", //normal accessorKey
      header: "RUC",
      accessorFn: (row) => `${row.cli_dv !== "" ? row.cli_ruc + " DV " + row.cli_dv : row.cli_ruc}`,
      align: "center",
      size: 100,
    },
    {
      accessorKey: "cli_email", //normal accessorKey
      header: "EMAIL",
      align: "center",
      size: 100,
    },
    {
      accessorKey: "cli_retencion",
      header: "RETENCIÓN",
      align: "center",
      size: 100,
      accessorFn: (row) => dataRetencion.find((item) => item.re_id === row.cli_retencion)?.re_desc ?? "",
    },
  ];
}

export const COLUMNS_PROVEEDORES = [
  {
    accessorKey: "prov_nombre",
    header: "NOMBRE",
    size: 350,
  },
  {
    accessorKey: "prov_telefono", //normal accessorKey
    header: "TELÉFONO",
    size: 100,
  },
  {
    accessorFn: (row) => `${row.prov_dv !== "" ? row.prov_ruc + " DV " + row.prov_dv : row.prov_ruc}`,
    accessorKey: "prov_ruc", //normal accessorKey
    header: "RUC",
    size: 100,
  },
];
export const COLUMNS_DESCUENTO = [
  {
    accessorKey: "des_number",
    header: "% DESCUENTO",
    size: 350,
  },
  {
    accessorKey: "des_code",
    header: "NOMBRE",
    size: 350,
  },
];
export const COLUMNS_MESAS =
  window.innerWidth <= 611
    ? [
        {
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="m-0">
                <Col xs={12} className="p-0">
                  <div className="usr-card-cell">
                    <div className="usr-card-top">
                      <div className="usr-card-main">
                        <div className="usr-card-user">{highlightText(row.original.res_nombre, search)}</div>
                      </div>
                    </div>
                    <Row className="g-2">
                      <Col xs={12}>
                        <div className="usr-card-meta">
                          <span>{highlightText(row.original.res_active === "1" ? "MESA ACTIVA" : "MESA INACTIVA", search)}</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            );
          },
          accessorKey: "res_nombre",
          header: "MESA",
          enableEditing: false,
        },
      ]
    : [
        {
          accessorKey: "res_id",
          header: "ID",
          minSize: 20,
          maxSize: 20,
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "res_nombre",
          header: "NOMBRE DE LA MESA",
        },
        {
          accessorKey: "res_active",
          header: "ESTADO DE LA MESA",
          accessorFn: (row) => `${row.res_active === "1" ? "MESA ACTIVA" : "MESA INACTIVA"}`,
          minSize: 50,
          maxSize: 50,
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];
export const COLUMNS_GARANTIA =
  window.innerWidth <= 611
    ? [
        {
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            const nombre = row.original.gr_name || "";
            const descripcion = row.original.gr_descripcion || "";

            return (
              <Row className="m-0">
                <Col xs={12} className="p-0">
                  <div className="gar-card-cell">
                    <div className="gar-card-header">
                      <div className="gar-card-icon">
                        <MDBIcon fas icon="shield-alt" />
                      </div>

                      <div className="gar-card-main">
                        <span className="gar-card-label">Garantía</span>

                        <strong className="gar-card-name">{highlightText(nombre, search)}</strong>
                      </div>
                    </div>

                    {descripcion && <div className="gar-card-description">{highlightText(descripcion, search)}</div>}
                  </div>
                </Col>
              </Row>
            );
          },

          accessorKey: "gr_name",
          header: "GARANTÍAS",
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "gr_name",
          header: "NOMBRE",
          size: 50,
        },
        {
          accessorKey: "gr_descripcion",
          header: "DESCRIPCIÓN",
          // size: 350,
        },
      ];
export const COLUMNS_MARCAS = [
  {
    accessorKey: "mar_descripcion",
    header: "MARCAS",
    size: 350,
  },
];
export const COLUMNS_CATEGORIAS = [
  {
    accessorKey: "cat_descripcion",
    header: "CATEGORÍAS",
    size: 350,
  },
  // {
  //   accessorKey: "co_desc",
  //   header: "COMANDA",
  //       muiTableBodyCellProps: {
  //     align: "center",
  //   },
  // },
];
export const COLUMNS_SERIES = [
  // {
  //   accessorKey: "ser_id",
  //   header: "ID",
  //      muiTableHeadCellProps: {
  //     align: "center",
  //   },
  //   muiTableBodyCellProps: {
  //     align: "center",
  //   },
  // },
  {
    accessorKey: "ser_serie",
    header: "SERIE",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "ser_conteo",
    header: "CANTIDAD",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "estado",
    header: "ESTADO",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },

  {
    accessorKey: "fac_id",
    header: "FACTURA",
    accessorFn: (row) => (row.fac_id === "0" ? "" : row.fac_id.toString().padStart(10, "0")),
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "usr_nombre",
    header: "VENDEDOR",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "bod_nombre",
    header: "BODEGA",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
];
export const COLUMNS_USUARIOS =
  window.innerWidth <= 611
    ? [
        {
          header: "USUARIOS",
          accessorFn: (row) => `${row.usr_usuario} ${row.usr_nombre} ${row.usr_perfil} ${row.com_nombre}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="m-0">
                <Col xs={12} className="p-0">
                  <div className="usr-card-cell">
                    <div className="usr-card-top">
                      <div className="usr-card-main">
                        <div className="usr-card-user">{highlightText(row.original.usr_usuario, search)}</div>
                        <div className="usr-card-name">{highlightText(row.original.usr_nombre, search)}</div>
                      </div>
                    </div>
                    <Row className="g-2">
                      <Col xs={12}>
                        <div className="usr-card-meta">
                          <span>{highlightText(row.original.com_nombre, search)}</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "usr_usuario",
          header: "USUARIO",
          grow: true,
          minSize: 80,
          maxSize: 120,
        },
        {
          accessorKey: "usr_nombre",
          header: "NOMBRE",
          minSize: 80,
          maxSize: 120,
        },
        {
          accessorFn: (row) => `${dataTipo[row.usr_perfil] !== undefined ? dataTipo[row.usr_perfil].label : null}`,
          accessorKey: "usr_perfil",
          header: "TIPO",
          minSize: 80,
          maxSize: 120,
        },
        {
          accessorKey: "com_nombre",
          accessorFn: (row) => `${row.com_nombre + " / " + row.com_alias}`,
          header: "SUCURSAL",
          minSize: 220,
          maxSize: 260,
        },
      ];
export function COLUMNS_PUBLICIDAD(setSrcImage, setModalImageTooltip) {
  return isMobileOrTablet
    ? [
        {
          Cell: ({ cell }) => {
            return (
              <>
                <img
                  className="img-art-datatable-publicidad"
                  alt=""
                  onClick={() => {
                    setSrcImage(imgURLLocalImageIp + cell.row.original.img_name);
                    setModalImageTooltip(true);
                  }}
                  src={imgURLLocalImageIp + cell.row.original.img_name}
                />
              </>
            );
          },
          accessorKey: "img_name",
          header: "IMÁGEN QUE SALDRA EN LA PUBLICIDAD",
          enableEditing: false,
        },
      ]
    : [
        {
          accessorKey: "img_id",
          header: "ID",
          minSize: 20,
          maxSize: 20,
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "img_name",
          Cell: ({ cell }) => {
            return (
              <>
                <img
                  className="img-art-datatable-publicidad"
                  alt=""
                  onClick={() => {
                    setSrcImage(imgURLLocalImageIp + cell.row.original.img_name);
                    setModalImageTooltip(true);
                  }}
                  src={imgURLLocalImageIp + cell.row.original.img_name}
                />
              </>
            );
          },
          header: "IMÁGEN QUE SALDRA EN LA PUBLICIDAD",
          // size: 360,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];
}
export function COLUMNS_ARTICULOS(openModalSeries) {
  const { dataCompania } = useContext(StoreContext);
  return window.innerWidth <= 611
    ? [
        {
          header: "ARTÍCULOS",
          accessorFn: (row) => `${row.art_upc} ${row.art_descripcion} ${row.art_serie} ${row.art_referencia}  ${row.art_costo} ${row.art_precio} ${row.art_precio2} ${row.art_precio3} ${row.art_itbm_venta}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b>CÓDIGO {highlightText(row.original.art_upc, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">{highlightText(row.original.art_descripcion, search)}</span>
                  <br></br>
                  <span className="font-w-14"># SERIE: {highlightText(row.original.art_serie, search)}</span>
                  <br></br>
                  <span className="font-w-14">REFERENCIA: {highlightText(row.original.art_referencia, search)}</span>
                  <br></br>
                  <span className="font-w-14">COSTO: {highlightText(row.original.art_costo, search)}</span>
                  <br></br>
                  <span className="font-w-14">PRECIO 1: {highlightText(row.original.art_precio, search)}</span>
                  <br></br>
                  <span className="font-w-14">PRECIO 2: {highlightText(row.original.art_precio2, search)}</span>
                  <br></br>
                  <span className="font-w-14">PRECIO 3: {highlightText(row.original.art_precio3, search)}</span>
                  <br></br>
                  <span className="font-w-14">ITBM DE VENTA: {highlightText((Number(row.original.art_itbm_venta) * 100).toFixed(2) + "%", search)}</span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "art_upc",
          header: "CÓDIGO",
          size: 150,
          muiTableHeadCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "art_referencia",
          header: "REFERENCIA",
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "series",
          header: "# SERIE",
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
          Cell: ({ cell }) => {
            return (
              <>
                {Number(cell.row.original.series) > 0 && (
                  <img
                    alt=""
                    className="img-art-datatable-2"
                    onClick={() => {
                      openModalSeries(cell.row.original);
                    }}
                    src={SEARCH_IMAGE}
                  />
                )}
              </>
            );
          },
        },
        {
          accessorKey: "art_restaurante",
          accessorFn: (row) => `${row.art_restaurante === "1" ? "SI" : ""}`,
          header: "RESTAURANTE",
          size: 150,
          muiTableHeadCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "co_desc",
          header: "COMANDA",
          size: 150,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "art_descripcion",
          header: "DESCRIPCIÓN",
          size: 350,
          muiTableHeadCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "art_servicio",
          header: dataCompania.com_lavanderia === "1" ? "CANASTA" : "SERVICIO",
          accessorFn: (row) => `${row.art_servicio === "1" ? "SI" : ""}`,
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "inv_qty",
          header: "CANTIDAD",
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "art_costo",
          header: "COSTO",
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "art_precio",
          header: "PRECIO",
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "art_precio2",
          header: "PRECIO 2",
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "art_precio3",
          header: "PRECIO 3",
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "cat_descripcion",
          header: "CATEGORIA",
          size: 50,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "prov_nombre",
          header: "PROVEEDOR",
          size: 50,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "mar_descripcion",
          header: "MARCA",
          size: 30,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },

        {
          accessorKey: "art_linea_roja",
          header: "LÍNEA ROJA",
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "art_itbm_venta",
          header: "ITBM VENTA",
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          accessorFn: (row) => `${(Number(row.art_itbm_venta) * 100).toFixed(2) + "%"}`,
        },
        {
          accessorKey: "art_itbm_compra",
          header: "ITBM COMPRA",
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          accessorFn: (row) => `${(Number(row.art_itbm_compra) * 100).toFixed(2) + "%"}`,
        },
        {
          accessorKey: "art_catalogo",
          header: "CATALOGO",
          accessorFn: (row) => `${row.art_catalogo === "1" ? "SI" : ""}`,
          size: 20,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];
}

export const COLUMNS_REPORT_INFORME_CAJA = [
  {
    accessorKey: "fac_fecha",
    header: "Fecha",
  },
  {
    accessorKey: "cli_nombre",
    header: "Cliente",
  },

  {
    accessorKey: "cli_ruc",
    header: "RUC",
  },
  {
    accessorKey: "usr_nombre",
    header: "Vendedor",
  },
  {
    accessorKey: "fac_caja",
    header: "Caja",
    // size: 450,
  },
  {
    accessorKey: "fac_motivo_anulacion",
    header: "Motivo",
    // size: 450,
  },
  {
    accessorKey: "fac_date_anulacion",
    header: "Fecha de anulacion",
    // size: 450,
  },
  {
    accessorKey: "fac_anulacion",
    header: "Anulacion",
    accessorFn: (row) => `${row.fac_anulacion === "1" ? "ANULADO" : ""}`,
    // size: 450,
  },
  {
    accessorKey: "fcd_precio",
    header: "Subtotal",
    // size: 450,
  },
  {
    accessorKey: "fcd_itbms",
    header: "ITBMS",
    // size: 450,
  },
  {
    accessorKey: "fcd_total",
    header: "TOTAL",
    // size: 450,
  },
];

export const COLUMNS_REPORT_VENTA = [
  {
    accessorKey: "fac_id", //access nested data with dot notation
    header: "N° documento",
    accessorFn: (row) => `${row.fac_id.toString().padStart(10, "0")}`,
    // size: 20,
  },
  {
    accessorKey: "fac_fecha",
    header: "Fecha",
    // size: 60,
  },
  {
    accessorKey: "cli_nombre",
    header: "Cliente",
    // size: 170,
  },

  {
    accessorKey: "cli_ruc",
    header: "RUC",
    // size: 40,
  },
  {
    accessorKey: "usr_nombre",
    header: "Vendedor",
    // size: 60,
  },
  {
    accessorKey: "fac_caja",
    header: "Caja",
    // size: 450,
  },
  {
    accessorKey: "fac_motivo_anulacion",
    header: "Motivo",
    // size: 450,
  },
  {
    accessorKey: "fac_date_anulacion",
    header: "Fecha de anulacion",
    // size: 450,
  },
  {
    accessorKey: "fac_anulacion",
    header: "Anulacion",
    accessorFn: (row) => `${row.fac_anulacion === "1" ? "ANULADO" : ""}`,
    // size: 450,
  },
  {
    accessorKey: "fcd_precio",
    header: "Subtotal",
    // size: 450,
  },
  {
    accessorKey: "fcd_itbms",
    header: "ITBMS",
    // size: 450,
  },
  {
    accessorKey: "fcd_total",
    header: "TOTAL",
    // size: 450,
  },
];
export const COLUMNS_AP_APARTADO = [
  {
    accessorKey: "ap_docn", //access nested data with dot notation
    header: "N° documento",
    size: 20,
  },
  {
    accessorKey: "dcd_total",
    header: "Monto",
    size: 60,
  },
  {
    accessorKey: "prov_proveedor",
    header: "Proveedor",
    size: 170,
  },

  {
    accessorKey: "ap_fecha",
    header: "Fecha de documento",
    size: 40,
  },
  {
    accessorKey: "ap_fecha_procesado",
    accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.ap_fecha_procesado))}`,
    header: "Fecha de procesado",
    size: 60,
  },
  {
    accessorKey: "ap_descripcion",
    header: "DESCRIPCIÓN",
    size: 450,
  },
];

export function COLUMNS_CPBS() {
  return [
    {
      accessorKey: "codigo",
      header: "CÓDIGO",
      size: 100,
    },
    {
      accessorKey: "descripcion",
      header: "DESCRIPCIÓN",
      size: 200,
    },
    {
      accessorKey: "segmento",
      header: "SEGMENTO",
      size: 100,
    },
    {
      accessorKey: "segmentoDescripcion",
      header: "DESCRIPCIÓN DEL SEGMENTO",
      size: 250,
    },
  ];
}
export function COLUMNS_DC_COMPRA() {
  return window.innerWidth <= 611
    ? [
        {
          header: "COMPRAS",

          accessorFn: (row) =>
            `${row.dc_docn || ""}  
       ${row.dcd_total || ""}  
       ${row.prov_proveedor || ""}  
       ${row.bod_nombre || ""}  
       ${row.com_alias || ""}  
       ${row.dc_fecha || ""}  
       ${row.dc_fecha_procesado || ""}  
       ${row.dc_descripcion || ""}`,

          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            const data = row.original;

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  {/* DOCUMENTO + MONTO */}
                  <Row className="g-2 align-items-center mb-2">
                    <Col xs={7}>
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "700",
                          color: "#36304a",
                        }}
                      >
                        DOC. {highlightText(data.dc_docn || "", search)}
                      </span>
                    </Col>

                    <Col xs={5} className="text-end">
                      <span
                        style={{
                          display: "inline-block",
                          background: "#edf8f1",
                          color: "#198754",
                          border: "1px solid #cfe9d7",
                          borderRadius: "8px",
                          padding: "4px 8px",
                          fontSize: "13px",
                          fontWeight: "700",
                        }}
                      >
                        ${highlightText(Number(data.dcd_total || 0).toFixed(2), search)}
                      </span>
                    </Col>
                  </Row>

                  {/* PROVEEDOR */}
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#222",
                      marginBottom: "7px",
                    }}
                  >
                    {highlightText(data.prov_proveedor || "", search)}
                  </div>

                  {/* BODEGA */}
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6c757d",
                      marginBottom: "2px",
                    }}
                  >
                    <b>BODEGA:</b> {highlightText(data.bod_nombre || "", search)}
                  </div>

                  {/* SUCURSAL */}
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6c757d",
                      marginBottom: "7px",
                    }}
                  >
                    <b>SUCURSAL:</b> {highlightText(data.com_alias || "", search)}
                  </div>

                  {/* FECHAS */}
                  <Row className="g-2">
                    <Col xs={6}>
                      <div
                        style={{
                          background: "#f7f8fb",
                          border: "1px solid #e5e9f0",
                          borderRadius: "8px",
                          padding: "5px 7px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "9px",
                            color: "#7b8492",
                            fontWeight: "700",
                          }}
                        >
                          F. DOCUMENTO
                        </div>

                        <div
                          style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            color: "#36304a",
                          }}
                        >
                          {data.dc_fecha === "0000-00-00 00:00:00" ? "" : moment(data.dc_fecha).format("YYYY-MM-DD")}
                        </div>
                      </div>
                    </Col>

                    <Col xs={6}>
                      <div
                        style={{
                          background: "#f7f8fb",
                          border: "1px solid #e5e9f0",
                          borderRadius: "8px",
                          padding: "5px 7px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "9px",
                            color: "#7b8492",
                            fontWeight: "700",
                          }}
                        >
                          F. PROCESADO
                        </div>

                        <div
                          style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            color: "#36304a",
                          }}
                        >
                          {data.dc_fecha_procesado === "0000-00-00 00:00:00" || data.dc_fecha_procesado === null ? "" : FORMATO_AM_PM(new Date(data.dc_fecha_procesado))}
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {/* DESCRIPCIÓN */}
                  {data.dc_descripcion && (
                    <div
                      style={{
                        marginTop: "8px",
                        paddingTop: "7px",
                        borderTop: "1px solid #eeeeee",
                        fontSize: "11px",
                        color: "#6c757d",
                      }}
                    >
                      <b>DESCRIPCIÓN:</b> {highlightText(data.dc_descripcion || "", search)}
                    </div>
                  )}
                </Col>
              </Row>
            );
          },

          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        /* =========================
           DESKTOP
           ========================= */

        {
          accessorKey: "dc_docn",
          header: "N° DOC.",
          size: 160,
          grow: false,
          minSize: 160,
          maxSize: 160,

          muiTableBodyCellProps: {
            align: "left",
          },
        },

        {
          accessorKey: "dcd_total",
          header: "MONTO",
          grow: false,
          minSize: 140,
          maxSize: 140,

          muiTableBodyCellProps: {
            align: "center",
          },
        },

        {
          accessorKey: "prov_proveedor",
          header: "PROVEEDOR",
          grow: false,
          minSize: 180,
          maxSize: 180,

          muiTableBodyCellProps: {
            align: "center",
          },
        },

        {
          accessorKey: "bod_nombre",
          header: "BODEGA",
          grow: false,
          minSize: 160,
          maxSize: 160,

          muiTableBodyCellProps: {
            align: "center",
          },
        },

        {
          accessorKey: "com_alias",
          header: "SUCURSAL",
          grow: false,
          minSize: 160,
          maxSize: 160,

          muiTableBodyCellProps: {
            align: "center",
          },
        },

        {
          accessorKey: "dc_fecha",

          accessorFn: (row) => `${row.dc_fecha === "0000-00-00 00:00:00" ? "" : moment(row.dc_fecha).format("YYYY-MM-DD")}`,

          header: "F. DOCUMENTO",

          minSize: 160,
          maxSize: 160,
          grow: false,

          muiTableBodyCellProps: {
            align: "center",
          },
        },

        {
          accessorKey: "dc_fecha_procesado",

          accessorFn: (row) => {
            return `${row.dc_fecha_procesado === "0000-00-00 00:00:00" || row.dc_fecha_procesado === null ? "" : FORMATO_AM_PM(new Date(row.dc_fecha_procesado))}`;
          },

          header: "F. PROCESADO",

          minSize: 160,
          maxSize: 160,
          grow: false,

          muiTableBodyCellProps: {
            align: "center",
          },
        },

        {
          accessorKey: "dc_descripcion",
          header: "DESCRIPCIÓN",
          size: 240,
          grow: true,
        },
      ];
}
export function COLUMNS_DC_COMPRA_DETALLE(deleteRow, onBlurs) {
  return [
    {
      accessorKey: "art_upc", //access nested data with dot notation
      header: "CÓDIGO",
      size: 80,
      minSize: 60,
      grow: false,
      enableEditing: false,
    },
    {
      accessorKey: "art_descripcion",
      header: "DESCRIPCIÓN",
      size: 270,
      minSize: 220,
      enableEditing: false,
    },
    {
      accessorKey: "art_serie",
      header: "SERIE",
      size: 40,
      minSize: 40,
      enableEditing: true,
    },
    {
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${new Decimal(cell.row.original.dcd_precio).toFixed(2)}`}</span>
            </Col>
          </Row>
        );
      },
      accessorKey: "dcd_precio",
      header: "PRECIO",
      size: 40,
      minSize: 40,
      enableEditing: false,
    },
    {
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${new Decimal(cell.row.original.dcd_cantidad).toFixed(2)}`}</span>
            </Col>
          </Row>
        );
      },
      accessorKey: "dcd_cantidad",
      header: "CANTIDAD",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      size: 40,
      minSize: 40,
    },
    {
      accessorKey: "dcd_itbms",
      header: "ITBMS",
      size: 40,
      minSize: 40,
      enableEditing: false,
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${MONEY_ROUND(cell.row.original.dcd_itbms === "" ? "0.00" : cell.row.original.dcd_itbms)}`}</span>
              {cell.row.original.art_itbm_compra === "0.00" ? <span className="porcent-label-exento">{"Ex"}</span> : <span className="porcent-label">{(Number(cell.row.original.art_itbm_compra) * 100).toFixed(0) + "%"}</span>}
            </Col>
          </Row>
        );
      },
    },
    {
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${MONEY_ROUND(cell.row.original.dcd_total)}`}</span>
            </Col>
          </Row>
        );
      },
      accessorKey: "dcd_total",
      header: "TOTAL",
      size: 60,
      minSize: 40,
      enableEditing: false,
    },
  ];
}
export function COLUMNS_BODEGAS() {
  return [
    {
      accessorKey: "bod_nombre",
      header: "BODEGA",
      // size: 350,
      enableEditing: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "inv_qty", //normal accessorKey
      header: "EXISTENCIA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      size: 100,
    },
    //     {
    //   accessorKey: "inv_qty", //normal accessorKey
    //   header: "MONTO",
    //   accessorFn: (row) => `${parseFloat(row.list_monto).toFixed(2)}`,
    //   muiTableHeadCellProps: {
    //     align: 'center',
    //   },
    //   muiTableBodyCellProps: {
    //     align: 'center',
    //   },
    //   size: 100,
    // },
  ];
}

export function COLUMNS_LISTA_FPAGO() {
  return window.innerWidth <= 611
    ? [
        {
          Cell: ({ cell }) => {
            return (
              <Row className="text-left">
                <Col xs={12}>
                  <span className="label-fpago">
                    <b>
                      {" "}
                      {cell.row.original.list_fpagoName} : {parseFloat(cell.row.original.list_monto).toFixed(2)}
                    </b>
                  </span>
                </Col>
              </Row>
            );
          },
          accessorKey: "list_fpagoName",
          header: "FORMA DE PAGO",
          grow: true,
          enableEditing: false,
        },
        {
          accessorKey: "list_monto", //normal accessorKey
          header: "MONTO",
          accessorFn: (row) => `${parseFloat(row.list_monto).toFixed(2)}`,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
      ]
    : [
        {
          accessorKey: "list_fpagoName",
          header: "FORMA DE PAGO",
          size: 350,
          enableEditing: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "list_monto", //normal accessorKey
          header: "MONTO",
          accessorFn: (row) => `${parseFloat(row.list_monto).toFixed(2)}`,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
      ];
}

export function COLUMNS_LISTA_ANULACION(setTabAnular, setFormAnulacion) {
  return window.innerWidth <= 611
    ? [
        {
          accessorKey: "fac_id",
          header: "ANULACIÓN",
          grow: true,
          // size:210,
          enableEditing: false,
          Cell: ({ cell }) => {
            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b> # FACTURA : {cell.row.original.fac_id.toString().padStart(10, "0")}</b>
                  </span>
                  <br></br>
                  <span>NOMBRE : {cell.row.original.cli_ruc !== "" ? cell.row.original.cli_nombre + " " + cell.row.original.cli_ruc : cell.row.original.cli_nombre}</span>
                  <br></br>
                  <span>FECHA : {FORMATO_AM_PM(new Date(cell.row.original.fac_fecha))}</span>
                  <br></br>
                  <span className="float-end label-money">
                    <b>TOTAL : ${new Decimal(cell.row.original.fac_total).toFixed(2)}</b>
                    <br></br>
                  </span>
                </Col>
              </Row>
            );
          },
        },
      ]
    : [
        {
          accessorKey: "fac_id",
          header: "# FACTURA",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
          size: 70,
          // accessorFn: (row) => `${<Label>{row.fac_id.toString().padStart(10, "0")}</Label>}`,
          Cell: ({ row, cell }) => {
            return (
              <Box className="d-flex">
                <Label className="class-btn-factura fw-bold text-dark">{row.original.fac_id.toString().padStart(10, "0")}</Label>
              </Box>
            );
          },
        },
        {
          accessorKey: "cli_nombre",
          accessorFn: (row) => `${row.cli_ruc !== "" ? row.cli_nombre + " " + row.cli_ruc : row.cli_nombre}`,
          header: "NOMBRE",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
        },
        {
          accessorKey: "fac_fecha",
          accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.fac_fecha))}`,
          header: "FECHA",
          size: 70,
          enableGlobalFilter: false,
          enableFilters: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          size: 70,
          accessorKey: "fac_total",
          header: "MONTO",
          accessorFn: (row) => `$${Number(row.fac_total).toFixed(2)} `,
        },
      ];
}

export function COLUMNS_LISTA_FACTURA(selectItemFCopia, getDetailItem, SetOpenDetailCopia, usr_print, setTabAnular, setFormAnulacion, setTabAnularNC) {
  const stringValue = (value) => String(value ?? "");
  const isAnulada = (data) => stringValue(data.fac_anulacion) === "1";
  const isProcesada = (data) => stringValue(data.fac_sts) === "1";
  const isFiscal = (data) => stringValue(data.fac_recibo) === "1";
  const isFactura = (data) => stringValue(data.fac_tipodocumento) === "01";
  const isNC = (data) => stringValue(data.fac_tipodocumento) === "04";

  const getTipoDocumento = (data) => {
    if (isNC(data)) {
      return {
        label: "NOTA DE CRÉDITO",
        detalle: data.fac_doc_nc ? `Ref. FE ${String(data.fac_doc_nc).padStart(10, "0")}` : "",
      };
    }

    if (isFactura(data) && !isFiscal(data)) {
      return {
        label: "RECIBO NO FISCAL",
        detalle: "",
      };
    }

    if (isFactura(data)) {
      return {
        label: "FACTURA DE OPERACIÓN INTERNA",
        detalle: "",
      };
    }

    return {
      label: "DOCUMENTO SIN TIPO",
      detalle: "",
    };
  };

  const getEstadoDocumento = (data) => {
    if (isAnulada(data)) {
      return {
        label: "ANULADA",
        color: "#a61b1b",
        background: "#ffd6d6",
        border: "#f59a9a",
      };
    }
    if (!isFiscal(data)) {
      if (isProcesada(data)) {
        return {
          label: "PROCESADO",
          color: "#05603a",
          background: "#c9f3dc",
          border: "#75d7a2",
        };
      }
      return {
        label: "PENDIENTE",
        color: "#9a4f00",
        background: "#ffe3a3",
        border: "#f3bd4f",
      };
    }
    if (isProcesada(data)) {
      return {
        label: "PROCESADA",
        color: "#05603a",
        background: "#c9f3dc",
        border: "#75d7a2",
      };
    }

    const resultado = stringValue(data.fac_resultado).toUpperCase();
    const mensaje = stringValue(data.fac_mensaje).toUpperCase();

    if (resultado.includes("COMUNICACIÓN") || resultado.includes("COMUNICACION") || mensaje.includes("COMUNICACIÓN") || mensaje.includes("COMUNICACION")) {
      return {
        label: "SIN CONFIRMAR",
        color: "#b26a00",
        background: "#fff8e1",
      };
    }

    if (resultado.length > 0 || mensaje.length > 0) {
      return {
        label: "ERROR HKA",
        color: "#dc3545",
        background: "#fff1f2",
      };
    }

    return {
      label: "PENDIENTE HKA",
      color: "#b26a00",
      background: "#fff8e1",
    };
  };

  const puedeImprimirRecibo = (data) => {
    const impresoraDisponible = usr_print === "2" || usr_print === "3" || usr_print === "4";
    if (!impresoraDisponible) {
      return false;
    }

    if (!isFiscal(data)) {
      return isProcesada(data);
    }

    return isProcesada(data) && (isFactura(data) || isNC(data));
  };

  const puedeImprimirPDF = (data) => {
    return isFiscal(data) && isProcesada(data) && (isFactura(data) || isNC(data));
  };

  const puedeAnular = (data) => {
    return !isAnulada(data) && isProcesada(data) && isFactura(data) && FECHA_MENOR_7DIAS(data.fac_fecha);
  };

  const puedeNotaCredito = (data) => {
    return !isAnulada(data) && isProcesada(data) && isFiscal(data) && isFactura(data);
  };

  const puedeDGI = (data) => {
    return isFiscal(data) && isProcesada(data) && stringValue(data.fac_cufe).length > 5;
  };

  const abrirDetalle = (data) => {
    getDetailItem({ data });
    SetOpenDetailCopia(true);
  };

  const abrirAnulacion = (data) => {
    setTabAnularNC(false);
    setTabAnular(true);
    setFormAnulacion({ ...data, motivo_anulacion: "" });
  };

  const abrirNC = (data) => {
    setTabAnular(false);
    setTabAnularNC(true);
    getDetailItem({ data });
    setFormAnulacion({ ...data, motivo_anulacion: "" });
  };

  const imprimirRecibo = (data) => {
    selectItemFCopia({ data, tipo: data.fac_recibo, print_type: "recibo" });
  };

  const imprimirPDF = (data) => {
    selectItemFCopia({ data, tipo: data.fac_recibo, print_type: "pdf" });
  };

  const abrirDGI = (data) => {
    window.open(`https://dgi-fep.mef.gob.pa/Consultas/FacturasPorCUFE/${data.fac_cufe}`, "_blank");
  };

  const RenderAcciones = ({ data }) => {
    return (
      <div
        className="d-flex align-items-center justify-content-center flex-wrap"
        style={{
          gap: "15px",
        }}
      >
        {puedeImprimirRecibo(data) && (
          <i
            title="Imprimir recibo"
            className="bi bi-printer class-btn-factura-datatable icon-size"
            style={{
              color: "#495057",
              cursor: "pointer",
            }}
            onClick={() => imprimirRecibo(data)}
          />
        )}
        {puedeImprimirPDF(data) && (
          <i
            title="Imprimir PDF"
            className="bi bi-file-earmark-pdf class-btn-factura-datatable icon-size"
            style={{
              color: "#e74c5b",
              cursor: "pointer",
            }}
            onClick={() => imprimirPDF(data)}
          />
        )}
        <i
          title="Ver factura"
          className="bi bi-search class-btn-factura-datatable icon-size"
          style={{
            color: "#24364b",
            cursor: "pointer",
          }}
          onClick={() => abrirDetalle(data)}
        />
        {puedeAnular(data) && (
          <i
            title="Anular"
            className="bi bi-trash class-btn-factura-datatable icon-size"
            style={{
              color: "#dc3545",
              cursor: "pointer",
            }}
            onClick={() => abrirAnulacion(data)}
          />
        )}
        {puedeNotaCredito(data) && (
          <i
            title="Nota de crédito"
            className="bi bi-file-earmark-text class-btn-factura-datatable icon-size"
            style={{
              color: "#198754",
              cursor: "pointer",
            }}
            onClick={() => abrirNC(data)}
          />
        )}
        {puedeDGI(data) && (
          <i
            title="Consultar DGI"
            className="bi bi-receipt class-btn-factura-datatable icon-size"
            style={{
              color: "#3478d4",
              cursor: "pointer",
            }}
            onClick={() => abrirDGI(data)}
          />
        )}
      </div>
    );
  };

  if (window.innerWidth <= 611) {
    return [
      {
        header: "FACTURA",
        accessorFn: (row) => `${row.fac_id} ${String(row.fac_id || "").padStart(10, "0")} ${row.fac_doc_nc || ""} ${row.fac_doc_nc ? String(row.fac_doc_nc).padStart(10, "0") : ""}  ${row.cli_nombre || ""} ${row.fac_fecha || ""}`,
        Cell: ({ row, table }) => {
          const data = row.original;
          const search = table.getState().globalFilter ?? "";
          const tipo = getTipoDocumento(data);
          const estado = getEstadoDocumento(data);
          return (
            <div style={{ padding: "5px 2px", lineHeight: "1.65" }}>
              <div className="fw-bold" style={{ fontSize: "14px", color: "#202938" }}>
                {isNC(data) ? <>NC LOCAL: {String(data.fac_id).padStart(10, "0")}</> : <># FACTURA {highlightText(String(data.fac_id).padStart(10, "0"), search)}</>}
              </div>
              {isNC(data) && data.fac_doc_nc && (
                <div
                  style={{
                    fontSize: "11px",
                    color: "#6b7280",
                  }}
                >
                  REFERENCIA FE: {String(data.fac_doc_nc).padStart(10, "0")}
                </div>
              )}
              <div>CLIENTE: {highlightText(data.cli_nombre || "", search)}</div>
              <div>
                MONTO: <strong>$ {Number(data.fac_total || 0).toFixed(2)}</strong>
              </div>
              <div>FECHA: {FORMATO_AM_PM(new Date(data.fac_fecha))}</div>

              <div
                style={{
                  marginTop: "5px",
                }}
              >
                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#36304a",
                  }}
                >
                  {tipo.label}
                </span>
              </div>
              {tipo.detalle && (
                <div
                  style={{
                    fontSize: "10px",
                    color: "#6b7280",
                  }}
                >
                  {tipo.detalle}
                </div>
              )}
              <div style={{ marginTop: "5px" }}>
                <span
                  style={{
                    color: estado.color,
                    background: estado.background,
                    border: `1px solid ${estado.border}`,
                    padding: "6px 12px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: 700,
                    minWidth: "105px",
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {estado.label}
                </span>
              </div>
            </div>
          );
        },
        filterFn: "fuzzy",
        enableGlobalFilter: true,
        enableEditing: false,
        grow: true,
      },
      {
        header: "OPCIONES",
        enableGlobalFilter: false,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        size: 80,
        Cell: ({ row }) => {
          return <RenderAcciones data={row.original} />;
        },
      },
    ];
  }
  return [
    {
      accessorKey: "fac_id",
      header: "# DOCUMENTO",
      enableGlobalFilter: true,
      size: 130,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
      id: "documento_busqueda",
      accessorFn: (row) => `${row.fac_id} ${String(row.fac_id || "").padStart(10, "0")}  ${row.fac_doc_nc || ""}  ${row.fac_doc_nc ? String(row.fac_doc_nc).padStart(10, "0") : ""}`,
      Cell: ({ row }) => {
        const data = row.original;
        return (
          <div>
            <div
              className="fw-bold"
              style={{
                color: "#202938",
                fontSize: "13px",
              }}
            >
              {String(data.fac_id).padStart(10, "0")}
            </div>
            {isNC(data) && data.fac_doc_nc && (
              <div
                style={{
                  color: "#6b7280",
                  fontSize: "10px",
                  marginTop: "2px",
                }}
              >
                Ref. FE {String(data.fac_doc_nc).padStart(10, "0")}
              </div>
            )}
          </div>
        );
      },
    },
    {
      accessorKey: "cli_nombre",
      accessorFn: (row) => `${row.cli_nombre || ""} ${row.cli_ruc || ""}`,
      header: "CLIENTE",
      enableGlobalFilter: true,
      size: 190,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
      Cell: ({ row }) => {
        return (
          <div>
            <div
              style={{
                fontWeight: "600",
                color: "#303847",
              }}
            >
              {row.original.cli_nombre}
            </div>
            {row.original.cli_ruc && (
              <div
                style={{
                  fontSize: "10px",
                  color: "#7b8492",
                }}
              >
                RUC {row.original.cli_ruc}
              </div>
            )}
          </div>
        );
      },
    },
    {
      accessorKey: "fac_total",
      accessorFn: (row) => `$ ${Number(row.fac_total || 0).toFixed(2)}`,
      header: "MONTO",
      size: 90,
      enableGlobalFilter: true,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ row }) => <span style={{ fontWeight: "600" }}>$ {Number(row.original.fac_total || 0).toFixed(2)}</span>,
    },
    {
      accessorKey: "fac_fecha",
      accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.fac_fecha))}`,
      header: "FECHA",
      size: 130,
      enableGlobalFilter: false,
      enableFilters: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      id: "tipo_documento",
      header: "DOCUMENTO",
      size: 190,
      enableGlobalFilter: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ row }) => {
        const tipo = getTipoDocumento(row.original);
        return (
          <div>
            <span
              style={{
                color: isNC(row.original) ? "#4939b8" : "#31343b",
                fontSize: "11px",
                fontWeight: "700",
                whiteSpace: "nowrap",
              }}
            >
              {tipo.label}
            </span>
            {tipo.detalle && <div style={{ fontSize: "9px", color: "#777", marginTop: "2px" }}>{tipo.detalle}</div>}
          </div>
        );
      },
    },
    {
      id: "estado_documento",
      header: "ESTADO",
      size: 110,
      enableGlobalFilter: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ row }) => {
        const data = row.original;
        const estado = getEstadoDocumento(data);
        return (
          <span
            title={data.fac_mensaje || data.fac_resultado || ""}
            style={{
              display: "inline-block",
              color: estado.color,
              background: estado.background,
              padding: "5px 10px",
              borderRadius: "20px",
              fontSize: "11px",
              fontWeight: "700",
              whiteSpace: "nowrap",
            }}
          >
            {estado.label}
          </span>
        );
      },
    },
    {
      id: "acciones",
      header: "ACCIONES",
      size: 170,
      enableGlobalFilter: false,
      enableSorting: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ row }) => {
        return <RenderAcciones data={row.original} />;
      },
    },
  ];
}

export function COLUMNS_LISTA_ITEMS_BODEGA() {
  return [
    {
      accessorKey: "art_upc",
      header: "CÓDIGO",
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
      enableGlobalFilter: true,
    },
    {
      accessorKey: "art_referencia",
      header: "REFERENCIA",
      size: 75,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: true,
    },
    {
      accessorKey: "art_descripcion", //normal accessorKey
      header: "DESCRIPCIÓN",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
      enableGlobalFilter: true,
    },
    {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: false,
      accessorKey: "mar_descripcion", //normal accessorKey
      header: "MARCA",
      size: 50,
    },
    {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: false,
      accessorKey: "cat_descripcion", //normal accessorKey
      header: "CATEGORIA",
      size: 80,
    },
    {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: false,
      accessorKey: "inv_qty", //normal accessorKey
      header: "EXISTENCIA",
      size: 70,
    },
    {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: false,
      accessorKey: "bod_nombre", //normal accessorKey
      header: "BODEGA",
      size: 50,
    },
    {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: false,
      accessorKey: "com_alias", //normal accessorKey
      header: "SUCURSAL",
      size: 80,
    },
  ];
}
const highlightText = (text, search) => {
  if (!search) return text;

  const regex = new RegExp(`(${search})`, "gi");
  return text.split(regex).map((part, i) =>
    regex.test(part) ? (
      <mark key={i} style={{ backgroundColor: "yellow", padding: 0 }}>
        {part}
      </mark>
    ) : (
      part
    )
  );
};
export function COLUMNS_LISTA_ITEMS() {
  return window.innerWidth <= 611
    ? [
        {
          header: "ARTÍCULO",
          accessorFn: (row) => `${row.art_upc} ${row.art_referencia} ${row.art_descripcion} ${row.mar_descripcion} ${row.art_precio}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            const upc = row.original.art_upc || "";
            const referencia = row.original.art_referencia || "";
            const descripcion = row.original.art_descripcion || "";
            const marca = row.original.mar_descripcion || "";
            const precio = Number(row.original.art_precio || 0).toFixed(2);

            return (
              <Row className="m-0">
                <Col xs={12} className="p-0">
                  <div className="art-card-cell">
                    <div className="art-card-header">
                      <div className="art-card-icon">
                        <MDBIcon fas icon="box" />
                      </div>

                      <div className="art-card-main">
                        <span className="art-card-code">{highlightText(upc, search)}</span>

                        <strong className="art-card-description">{highlightText(descripcion, search)}</strong>
                      </div>
                    </div>

                    <Row className="g-2 mt-2">
                      <Col xs={6}>
                        <div className="art-card-meta">
                          <MDBIcon fas icon="barcode" />

                          <div>
                            <span className="art-card-meta-label">Referencia</span>

                            <strong>{referencia ? highlightText(referencia, search) : "Sin referencia"}</strong>
                          </div>
                        </div>
                      </Col>

                      <Col xs={6}>
                        <div className="art-card-meta">
                          <MDBIcon fas icon="tag" />

                          <div>
                            <span className="art-card-meta-label">Marca</span>

                            <strong>{marca ? highlightText(marca, search) : "Sin marca"}</strong>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="art-card-footer">
                      <span>Precio</span>

                      <strong>${precio}</strong>
                    </div>
                  </div>
                </Col>
              </Row>
            );
          },

          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "art_upc",
          header: "CÓDIGO",
          size: 70,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
          enableGlobalFilter: true,
        },
        {
          accessorKey: "art_referencia",
          header: "REFERENCIA",
          size: 70,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
          enableGlobalFilter: true,
        },
        {
          accessorKey: "art_descripcion", //normal accessorKey
          header: "DESCRIPCIÓN",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
          enableGlobalFilter: true,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "art_costo", //normal accessorKey
          header: "COSTO",
          size: 50,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "art_precio", //normal accessorKey
          header: "PRECIO",
          size: 50,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "art_precio2", //normal accessorKey
          header: "PRECIO 2",
          size: 50,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "art_precio3", //normal accessorKey
          header: "PRECIO 3",
          size: 50,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "inv_qty", //normal accessorKey
          header: "CANTIDAD",
          size: 50,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "itbm_descripcion", //normal accessorKey
          header: "ITBMS",
          size: 50,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "mar_descripcion", //normal accessorKey
          header: "MARCA",
          size: 50,
        },
      ];
}

export const COLUMNS_COT_COTIZACION =
  window.innerWidth <= 611
    ? [
        {
          header: "COTIZACIÓN",
          accessorFn: (row) => `${row.art_upc} ${row.cli_nombre} ${row.cli_ruc} ${row.com_alias} ${row.cot_fecha} ${row.cotd_total}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            const cotizacion = row.original.cot_id || "";
            const cliente = row.original.cli_nombre || "";
            const ruc = row.original.cli_ruc || "";
            const sucursal = row.original.com_alias || "";
            const fecha = row.original.cot_fecha || "";
            const total = MONEY_ROUND(row.original.cotd_total || 0);

            return (
              <Row className="m-0 min-w-100">
                <Col xs={12} className="p-0 w-100">
                  <div className="cot-mobile-row">
                    {/* COTIZACIÓN + FECHA */}
                    <Row className="g-0 align-items-center">
                      <Col xs={7}>
                        <div className="cot-mobile-header">
                          <div className="cot-mobile-icon">
                            <MDBIcon fas icon="file-invoice" />
                          </div>

                          <div>
                            <span className="cot-mobile-label">Cotización</span>

                            <strong className="cot-mobile-number">#{highlightText(cotizacion, search)}</strong>
                          </div>
                        </div>
                      </Col>

                      <Col xs={5} className="text-end">
                        <div className="cot-mobile-date">
                          <MDBIcon fas icon="calendar-alt" />
                          <span>{highlightText(fecha, search)}</span>
                        </div>
                      </Col>
                    </Row>

                    {/* CLIENTE */}
                    <Row className="g-0 mt-2">
                      <Col xs={12}>
                        <div className="cot-mobile-client">
                          <span>Cliente</span>

                          <strong>{highlightText(cliente, search)}</strong>

                          {ruc && <small>{highlightText(ruc, search)}</small>}
                        </div>
                      </Col>
                    </Row>

                    {/* SUCURSAL + TOTAL */}
                    <Row className="g-0 align-items-end cot-mobile-bottom">
                      <Col xs={7}>
                        <div className="cot-mobile-branch">
                          <span>Sucursal</span>

                          <strong>{highlightText(sucursal, search)}</strong>
                        </div>
                      </Col>

                      <Col xs={5}>
                        <div className="cot-mobile-money">
                          <span>Total</span>
                          <strong>${total}</strong>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "cot_id", //access nested data with dot notation
          header: "# COTIZACIÓN",
          size: 150,
          minSize: 150,
          maxSize: 250,
          muiTableBodyCellProps: {
            align: "center",
          },
          grow: false,
        },
        {
          accessorKey: "cli_nombre",
          accessorFn: (row) => `${row.cli_nombre + " / " + row.cli_ruc}`,
          header: "CLIENTE",
          grow: true,
          Edit: () => null,
          enableEditing: false,
        },
        {
          accessorKey: "com_alias",
          header: "SUCURSAL",
          muiTableBodyCellProps: {
            align: "center",
          },
          grow: true,
          Edit: () => null,
          enableEditing: false,
        },
        {
          accessorKey: "cot_fecha", //normal accessorKey
          header: "FECHA",
          size: 120,
          minSize: 120,
          maxSize: 140,
          grow: false,
          Edit: () => null,
          enableEditing: false,
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "cotd_total",
          header: "MONTO",
          accessorFn: (row) => `$ ${MONEY_ROUND(row.cotd_total)}`,
          size: 120,
          minSize: 120,
          maxSize: 140,
          grow: false,
          Edit: () => null,
          enableEditing: false,
        },
      ];

export function COLUMNS_FAC_FACTURA_DETALLE2(deleteRow, onBlurs) {
  return [
    {
      accessorKey: "fac_id",
      // size: 60,
      // minSize:40,
      header: "",
      enableHiding: false,
      enableEditing: false,
      columnVisibility: false,
      Cell: ({ row, cell }) => {
        return (
          <Box className="width-box-delete2">
            <Row>
              <Col xs={6}>
                <Label>ARTICULO</Label>
              </Col>
              <Col xs={2}>
                <Label>CANT</Label>
              </Col>
              <Col xs={2}>
                <Label>PRECIO</Label>
              </Col>
              <Col xs={2}>
                <Label>TOTAL</Label>
              </Col>
            </Row>
            <Row>{}</Row>
            <IconButton color="error" onClick={() => deleteRow(row)}>
              <DeleteIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];
}

const ChefBadge = () => (
  <span
    aria-label="En cocina"
    title="En cocina"
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 24,
      height: 24,
      borderRadius: "50%",
      background: "var(--rt-accent-soft, #f7e6c6)",
      color: "#8a6a17",
      flexShrink: 0,
    }}
  >
    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z" />
      <line x1="6" y1="17" x2="18" y2="17" />
    </svg>
  </span>
);
export function COLUMNS_ORDENES_DETALLE_RESTAURANTE(usr_precio) {
  return [
    {
      accessorKey: "art_descripcion",
      header: "DESCRIPCIÓN",
      size: 200,
      minSize: 200,
      id: "art_descripcion",
      grow: true,
      // Se muestra en el modal de edición, pero deshabilitada (solo lectura)
      enableEditing: true,
      Edit: ({ row }) => (
        <label
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            fontFamily: "var(--rt-sans, inherit)",
          }}
        >
          <span style={{ fontSize: "0.72rem", color: "var(--rt-muted, #6b7280)" }}>Descripción</span>
          <input
            type="text"
            value={row.original.art_descripcion}
            disabled
            readOnly
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid var(--rt-border, #e5e7eb)",
              background: "var(--rt-bg, #f3f4f6)",
              color: "var(--rt-muted, #6b7280)",
              fontSize: "0.9rem",
              cursor: "not-allowed",
            }}
          />
        </label>
      ),
      // enableEditing: false,
      Cell: ({ cell }) => {
        const enCocina = cell.row.original.ordd_entregado === "0";
        const precio = Number.parseFloat(cell.row.original.ordd_precio).toFixed(2);
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {enCocina && <ChefBadge />}
            {/* <span style={{ lineHeight: 1.25 }}>{cell.row.original.art_descripcion}</span> */}
            <div style={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }}>
              <span style={{ lineHeight: 1.25, fontWeight: "600" }}>{cell.row.original.art_descripcion}</span>
              <span
                style={{
                  fontFamily: "var(--rt-mono, monospace)",
                  fontSize: "0.72rem",
                  color: "var(--rt-muted, #6b7280)",
                }}
              >
                {`B/. ${precio} c/u`}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: "ordd_cantidad",
      accessorFn: (row) => `${Number.parseFloat(row.ordd_cantidad).toFixed(2)}`,
      header: "CANT.",
      size: 45,
      grow: true,
      minSize: 45,
      enableEditing: true,
      // Editor personalizado: solo números en el modal de edición
      Edit: ({ row, table }) => {
        const editValues = row._valuesCache;
        return (
          <label
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 4,
              fontFamily: "var(--rt-sans, inherit)",
            }}
          >
            <span style={{ fontSize: "0.72rem", color: "var(--rt-muted, #6b7280)" }}>Cantidad</span>
            <input
              type="number"
              min="0"
              step="1"
              inputMode="numeric"
              defaultValue={row.original.ordd_cantidad}
              // Bloquea letras y caracteres no numéricos al teclear
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
              }}
              onChange={(e) => {
                // Solo dígitos (elimina cualquier otro carácter)
                const soloNumeros = e.target.value.replace(/[^0-9]/g, "");
                e.target.value = soloNumeros;
                editValues.ordd_cantidad = soloNumeros;
                row._valuesCache = editValues;
                table.setEditingRow({ ...row });
              }}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 8,
                border: "1px solid var(--rt-border, #e5e7eb)",
                background: "var(--rt-surface, #fff)",
                color: "var(--rt-text, #111827)",
                fontSize: "0.9rem",
                fontFamily: "var(--rt-mono, monospace)",
              }}
            />
          </label>
        );
      },
    },
    {
      accessorFn: (row) => `$${roundNumber(Number(row.ordd_total), 2).toFixed(2)}`,
      accessorKey: "ordd_total",
      header: "TOTAL",
      size: 35,
      minSize: 35,
      maxSize: 35,
      grow: true,
      Edit: () => null,
      enableEditing: false,
    },
  ];
}
// export function COLUMNS_ORDENES_DETALLE_RESTAURANTE(usr_precio) {
//   return [
//     {
//       accessorKey: "art_descripcion",
//       header: "DESCRIPCIÓN",
//       size: 200,
//       minSize: 200,
//       id: "art_descripcion",
//       grow: true,
//       Edit: () => null,
//       enableEditing: false,
//       Cell: ({ cell }) => {
//         return (
//           <>
//             <Col xs={2}>
//               {cell.row.original.ordd_entregado === "0" && (
//                 <img src={COOK_MAN} className="img-cook" alt="..." />
//               )}
//             </Col>
//             <Col xs={10}>
//               <span>{cell.row.original.art_descripcion}</span>
//             </Col>
//           </>
//         );
//       },
//     },
//     {
//       accessorKey: "ordd_precio",
//       header: "PRECIO",
//       accessorFn: (row) => `$${parseFloat(row.ordd_precio).toFixed(2)}`,
//       size: 35,
//       minSize: 35,
//       grow: true,
//       // Edit: () => null,
//       enableEditing: false,
//     },
//     {
//       accessorKey: "ordd_cantidad",
//       accessorFn: (row) => `${parseFloat(row.ordd_cantidad).toFixed(2)}`,
//       header: "CANTIDAD",
//       size: 45,
//       grow: true,
//       minSize: 45,
//     },
//     {
//       accessorFn: (row) => `$${roundNumber(Number(row.ordd_total),2).toFixed(2)}`,
//       accessorKey: "ordd_total",
//       header: "TOTAL",
//       size: 35,
//       minSize: 35,
//       maxSize: 35,
//       grow: true,
//       Edit: () => null,
//       enableEditing: false,
//     },
//   ];
// }
export function COLUMNS_FAC_FACTURA_DETALLE_ENABLE_ONLY_DESCUENTO(usr_precio) {
  return [
    {
      accessorKey: "art_upc",
      header: "CÓDIGO",
      minSize: 160,
      grow: true,
      enableEditing: false,
    },
    {
      accessorKey: "art_descripcion",
      header: "DESCRIPCIÓN",
      minSize: 400,
      maxSize: 500,
      grow: true,
      enableEditing: false,
    },
    {
      accessorKey: "fcd_precio",
      header: "PRECIO",
      accessorFn: (row) => `${new Decimal(row.fcd_precio).toFixed(2)}`,
      minSize: 60,
      maxSize: 80,
      grow: false,
      enableEditing: false,
    },
    {
      accessorKey: "fcd_cantidad",
      accessorFn: (row) => `${new Decimal(row.fcd_cantidad).toFixed(2)}`,
      header: "CANTIDAD",
      grow: false,
      minSize: 80,
      enableEditing: false,
    },
    {
      accessorKey: "fcd_descuento",
      accessorFn: (row) => `${parseFloat(row.fcd_descuento === "" ? "0.00" : MONEY_ROUND(row.fcd_descuento)).toFixed(2)}`,
      header: "DESC. %",
      size: 80,
      enableEditing: false,
      minSize: 80,
      grow: false,
      Cell: ({ cell }) => {
        return (
          <div className="text-center">
            <span>{`${MONEY_ROUND(cell.row.original.fcd_descuento === "" ? "0.00" : cell.row.original.fcd_descuento)}`}</span>
            {Number(cell.row.original.fcd_descuento) === Number("0.00") ? null : <span className="porcent-label">{Number(cell.row.original.fcd_descuento_number).toFixed(0) + "%"}</span>}
          </div>
        );
      },
    },
    {
      accessorKey: "fcd_descuento_number",
      header: "DESC. NÚMERO",
      size: 60,
      grow: true,
      minSize: 60,
      enableEditing: true,
    },
    {
      accessorKey: "fcd_itbms",
      header: "ITBMS",
      minSize: 90,
      maxSize: 110,
      id: "fcd_itbms",
      grow: false,
      Edit: () => null,
      enableEditing: false,
      Cell: ({ cell }) => {
        return (
          <>
            <span>{`${MONEY_ROUND(cell.row.original.fcd_itbms === "" ? "0.00" : cell.row.original.fcd_itbms)}`}</span>
            {cell.row.original.art_itbm_venta === "0.00" ? <span className="porcent-label-exento">{"Ex"}</span> : <span className="porcent-label">{(Number(cell.row.original.art_itbm_venta) * 100).toFixed(0) + "%"}</span>}
          </>
        );
      },
    },
    {
      accessorFn: (row) => `${MONEY_ROUND(row.fcd_total)}`,
      accessorKey: "fcd_total",
      header: "TOTAL",
      minSize: 70,
      maxSize: 110,
      grow: false,
      Edit: () => null,
      enableEditing: false,
    },
  ];
}
export function COLUMNS_FAC_FACTURA_DETALLE_COPIA() {
  return window.innerWidth <= 611
    ? [
        {
          header: "ARTÍCULO",
          accessorFn: (row) => `${row.art_upc} ${row.art_categoria} ${row.art_descripcion} ${row.art_marca} ${row.art_linea_roja} ${row.inv_qty} `,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b> {highlightText(row.original.art_upc, search)}</b>
                  </span>
                  <br></br>
                  <span>{highlightText(row.original.fcd_art_descripcion, search)}</span>
                  <br></br>
                  {Number(row.original.fcd_descuento) === Number("0.00") ? "Desc." : <span className="porcent-label"> Desc. {MONEY_ROUND(row.original.fcd_descuento)}</span>} <br></br>
                  <span>
                    {`I.T.B.M.S. = ${MONEY_ROUND(row.original.fcd_itbms === "" ? "0.00" : row.original.fcd_itbms)}`}
                    {row.original.art_itbm_venta === "0.00" ? <span className="porcent-label-exento">{"Ex"}</span> : <span className="porcent-label">{(Number(row.original.art_itbm_venta) * 100).toFixed(0) + "%"}</span>}
                  </span>
                  <span className="float-end label-money">
                    <b>
                      {Number(row.original.fcd_precio).toFixed(2)} x {row.original.fcd_cantidad} = {highlightText(MONEY_ROUND(row.original.fcd_total), search)}
                    </b>
                    <br></br>
                  </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "art_upc",
          header: "CÓDIGO",
          minSize: 60,
          grow: false,
          enableEditing: false,
        },
        {
          accessorKey: "fcd_art_descripcion",
          header: "DESCRIPCIÓN",
          // minSize: 300,
          // maxSize: 350,
          grow: true,
        },
        {
          accessorKey: "fcd_precio",
          header: "PRECIO",
          accessorFn: (row) => `${new Decimal(row.fcd_precio).toFixed(2)}`,
          minSize: 110,
          maxSize: 110,
          muiTableBodyCellProps: {
            align: "center",
          },
          grow: false,
        },
        {
          accessorKey: "fcd_cantidad",
          accessorFn: (row) => `${new Decimal(row.fcd_cantidad).toFixed(2)}`,
          header: "CANTIDAD",
          grow: false,
          muiTableBodyCellProps: {
            align: "center",
          },
          minSize: 120,
          maxSize: 120,
        },
        {
          accessorKey: "fcd_descuento",
          accessorFn: (row) => `${MONEY_ROUND(row.fcd_descuento === "" ? "0.00" : row.fcd_descuento)}`,
          header: "DESC. %",
          size: 100,
          enableEditing: false,
          minSize: 100,
          muiTableBodyCellProps: {
            align: "center",
          },
          grow: false,
        },
        {
          accessorKey: "fcd_itbms",
          accessorFn: (row) => `${MONEY_ROUND(row.fcd_itbms)}`,
          header: "ITBMS",
          minSize: 110,
          maxSize: 110,
          id: "fcd_itbms",
          muiTableBodyCellProps: {
            align: "center",
          },
          grow: false,
          Edit: () => null,
          enableEditing: false,
        },
        {
          accessorFn: (row) => `${MONEY_ROUND(row.fcd_total)}`,
          accessorKey: "fcd_total",
          header: "TOTAL",
          minSize: 70,
          maxSize: 110,
          muiTableBodyCellProps: {
            align: "center",
          },
          grow: false,
          Edit: () => null,
          enableEditing: false,
        },
      ];
}
export function COLUMNS_FAC_FACTURA_DETALLE(usr_precio) {
  return window.innerWidth <= 611
    ? [
        {
          accessorKey: "art_upc",
          header: "ARTÍCULO",
          grow: true,
          enableEditing: false,
          Cell: ({ cell }) => {
            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b> {cell.row.original.art_upc}</b>
                  </span>
                  <br></br>
                  <span>{cell.row.original.art_descripcion}</span>
                  <br></br>
                  {Number(cell.row.original.fcd_descuento) === Number("0.00") ? "Desc." : <span className="porcent-label"> Desc. {Number(cell.row.original.fcd_descuento_number).toFixed(0) + "%"}</span>} <br></br>
                  <span>{`I.T.B.M.S. = ${MONEY_ROUND(cell.row.original.fcd_itbms === "" ? "0.00" : cell.row.original.fcd_itbms)} `}</span>
                  {cell.row.original.art_itbm_venta === "0.00" ? <span className="porcent-label-exento">{"Ex"}</span> : <span className="porcent-label">{(Number(cell.row.original.art_itbm_venta) * 100).toFixed(0) + "%"}</span>}
                  <br></br>
                  <span className="float-end label-money">
                    <b>
                      {Number(cell.row.original.fcd_precio).toFixed(2)} x {cell.row.original.fcd_cantidad} = {MONEY_ROUND(cell.row.original.fcd_total)}
                    </b>
                    <br></br>
                  </span>
                </Col>
              </Row>
            );
          },
        },
        {
          accessorKey: "art_descripcion",
          header: "DESCRIPCIÓN",
          minSize: 400,
          maxSize: 500,
          grow: true,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "fcd_precio",
          header: "PRECIO",
          accessorFn: (row) => `${new Decimal(row.fcd_precio).toFixed(2)}`,
          minSize: 60,
          maxSize: 80,
          grow: false,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "fcd_cantidad",
          accessorFn: (row) => `${new Decimal(row.fcd_cantidad).toFixed(2)}`,
          header: "CANTIDAD",
          grow: false,
          columnVisibility: false,
          minSize: 80,
          maxSize: 100,
        },
        {
          accessorKey: "fcd_descuento",
          accessorFn: (row) => `${row.fcd_descuento === "" ? "0.00" : MONEY_ROUND(row.fcd_descuento)}`,
          header: "DESC. %",
          size: 80,
          enableEditing: false,
          minSize: 80,
          grow: false,
          Cell: ({ cell }) => {
            return (
              <div className="text-center">
                <span>{`${MONEY_ROUND(cell.row.original.fcd_descuento === "" ? "0.00" : cell.row.original.fcd_descuento)}`}</span>
                {Number(cell.row.original.fcd_descuento) === Number("0.00") ? null : <span className="porcent-label">{Number(cell.row.original.fcd_descuento_number).toFixed(0) + "%"}</span>}
              </div>
            );
          },
        },
        {
          accessorKey: "fcd_descuento_number",
          header: "DESC. NÚMERO",
          size: 60,
          grow: true,
          minSize: 60,
        },
      ]
    : [
        {
          accessorKey: "art_upc",
          header: "CÓDIGO",
          minSize: 160,
          grow: true,
          enableEditing: false,
        },
        {
          accessorKey: "art_descripcion",
          header: "DESCRIPCIÓN",
          minSize: 400,
          maxSize: 500,
          grow: true,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "fcd_precio",
          header: "PRECIO",
          accessorFn: (row) => `${new Decimal(row.fcd_precio).toFixed(2)}`,
          minSize: 60,
          maxSize: 80,
          grow: false,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "fcd_cantidad",
          accessorFn: (row) => `${new Decimal(row.fcd_cantidad).toFixed(2)}`,
          header: "CANTIDAD",
          grow: false,
          minSize: 80,
          maxSize: 100,
        },
        {
          accessorKey: "fcd_descuento",
          accessorFn: (row) => `${row.fcd_descuento === "" ? "0.00" : MONEY_ROUND(row.fcd_descuento)}`,
          header: "DESC. %",
          size: 80,
          enableEditing: false,
          minSize: 80,
          grow: false,
          Cell: ({ cell }) => {
            return (
              <div className="text-center">
                <span>{`${cell.row.original.fcd_descuento === "" ? "0.00" : MONEY_ROUND(cell.row.original.fcd_descuento)}`}</span>
                {Number(cell.row.original.fcd_descuento) === Number("0.00") ? null : <span className="porcent-label">{Number(cell.row.original.fcd_descuento_number).toFixed(0) + "%"}</span>}
              </div>
            );
          },
        },
        {
          accessorKey: "fcd_descuento_number",
          header: "DESC. NÚMERO",
          size: 60,
          grow: true,
          minSize: 60,
        },
        {
          accessorKey: "fcd_itbms",
          header: "ITBMS",
          minSize: 90,
          maxSize: 110,
          id: "fcd_itbms",
          grow: false,
          Edit: () => null,
          enableEditing: false,
          Cell: ({ cell }) => {
            return (
              <>
                <span>{`${MONEY_ROUND(cell.row.original.fcd_itbms === "" ? "0.00" : cell.row.original.fcd_itbms)}`}</span>
                {cell.row.original.art_itbm_venta === "0.00" ? <span className="porcent-label-exento">{"Ex"}</span> : <span className="porcent-label">{(Number(cell.row.original.art_itbm_venta) * 100).toFixed(0) + "%"}</span>}
              </>
            );
          },
        },
        {
          accessorFn: (row) => `${MONEY_ROUND(row.fcd_total)}`,
          accessorKey: "fcd_total",
          header: "TOTAL",
          minSize: 70,
          maxSize: 110,
          grow: false,
          Edit: () => null,
          enableEditing: false,
        },
      ];
}

export function COLUMNS_COTD_COOTIZACION_DETALLE(usr_precio) {
  return window.innerWidth <= 611
    ? [
        {
          accessorFn: (row) => `${row.art_upc} ${row.cotd_precio} ${row.art_descripcion} ${row.cotd_cantidad} ${row.cotd_descuento}`,
          accessorKey: "art_upc",
          header: "ARTÍCULO",
          grow: true,
          enableEditing: false,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            const descuento = Number(row.original.cotd_descuento || 0);
            const descuentoPct = Number(row.original.cotd_descuento_number || 0);

            const itbms = MONEY_ROUND(row.original.cotd_itbms === "" ? "0.00" : row.original.cotd_itbms);

            const precio = Number(row.original.cotd_precio || 0).toFixed(2);
            const cantidad = row.original.cotd_cantidad || 0;
            const total = MONEY_ROUND(row.original.cotd_total || 0);

            const esExento = row.original.art_itbm_venta === "0.00";

            return (
              <Row className="m-0">
                <Col xs={12} className="p-0">
                  <div className="cot-mobile-item">
                    <div className="cot-mobile-item-header">
                      <span className="cot-mobile-code">{highlightText(row.original.art_upc, search)}</span>
                    </div>

                    <div className="cot-mobile-description">{highlightText(row.original.art_descripcion, search)}</div>

                    <div className="cot-mobile-meta">
                      <div className="cot-mobile-meta-item">
                        <span>Desc.</span>

                        {descuento > 0 ? <strong className="cot-badge cot-badge-discount">{descuentoPct.toFixed(0)}%</strong> : <strong>0%</strong>}
                      </div>

                      <div className="cot-mobile-meta-item">
                        <span>ITBMS</span>

                        <strong>{itbms}</strong>

                        {esExento ? <span className="cot-badge cot-badge-exento">Ex</span> : <span className="cot-badge cot-badge-tax">{(Number(row.original.art_itbm_venta || 0) * 100).toFixed(0)}%</span>}
                      </div>
                    </div>

                    <div className="cot-mobile-total">
                      <span>
                        {precio} × {cantidad}
                      </span>

                      <strong>${total}</strong>
                    </div>
                  </div>
                </Col>
              </Row>
            );
          },
        },
        {
          accessorKey: "art_descripcion",
          header: "DESCRIPCIÓN",
          minSize: 400,
          maxSize: 500,
          grow: true,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "cotd_precio",
          header: "PRECIO",
          accessorFn: (row) => `${new Decimal(row.cotd_precio).toFixed(2)}`,
          minSize: 60,
          maxSize: 80,
          grow: false,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "cotd_cantidad",
          accessorFn: (row) => `${new Decimal(row.cotd_cantidad).toFixed(2)}`,
          header: "CANTIDAD",
          grow: false,
          columnVisibility: false,
          minSize: 80,
          maxSize: 100,
        },
        {
          accessorKey: "cotd_descuento",
          accessorFn: (row) => `${MONEY_ROUND(row.cotd_descuento === "" ? "0.00" : row.cotd_descuento)}`,
          header: "DESC. %",
          size: 80,
          enableEditing: false,
          minSize: 80,
          grow: false,
          Cell: ({ cell }) => {
            return (
              <div className="text-center">
                <span>{`${MONEY_ROUND(cell.row.original.cotd_descuento === "" ? "0.00" : cell.row.original.cotd_descuento)}`}</span>
                {Number(cell.row.original.cotd_descuento) === Number("0.00") ? null : <span className="porcent-label">{Number(cell.row.original.cotd_descuento_number).toFixed(0) + "%"}</span>}
              </div>
            );
          },
        },
        {
          accessorKey: "cotd_descuento_number",
          header: "DESC. NÚMERO",
          size: 60,
          grow: true,
          minSize: 60,
        },
      ]
    : [
        {
          accessorKey: "art_upc",
          header: "CÓDIGO",
          size: 80,
          minSize: 80,
          enableEditing: false,
        },
        {
          accessorKey: "art_descripcion",
          header: "DESCRIPCIÓN",
          size: 230,
          minSize: 200,
          enableEditing: false,
        },
        {
          accessorFn: (row) => `${new Decimal(row.cotd_precio).toFixed(2)}`,
          accessorKey: "cotd_precio",
          header: "PRECIO",
          size: 60,
          minSize: 60,
          enableEditing: usr_precio === "1" ? true : false,
          muiTableBodyCellProps: {
            align: "center",
          },
        },

        {
          accessorFn: (row) => `${new Decimal(row.cotd_cantidad).toFixed(2)}`,
          accessorKey: "cotd_cantidad",
          header: "CANTIDAD",
          size: 60,
          minSize: 60,
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "cotd_descuento",
          accessorFn: (row) => `${parseFloat(row.cotd_descuento === "" ? "0.00" : MONEY_ROUND(row.cotd_descuento)).toFixed(2)}`,
          header: "DESC. %",
          size: 60,
          grow: true,
          minSize: 60,
          enableEditing: false,
          muiTableBodyCellProps: {
            align: "center",
          },
          Cell: ({ cell }) => {
            return (
              <div className="text-center">
                <span>{`${MONEY_ROUND(cell.row.original.cotd_descuento === "" ? "0.00" : cell.row.original.cotd_descuento)}`}</span>
                {Number(cell.row.original.cotd_descuento) === Number("0.00") ? null : <span className="porcent-label">{Number(cell.row.original.cotd_descuento_number).toFixed(0) + "%"}</span>}
              </div>
            );
          },
        },
        {
          accessorKey: "cotd_descuento_number",
          header: "DESC. NÚMERO",
          size: 60,
          grow: true,
          minSize: 60,
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "cotd_itbms",
          header: "ITBMS",
          size: 60,
          minSize: 60,
          enableEditing: false,
          muiTableBodyCellProps: {
            align: "center",
          },
          Edit: () => null,
          Cell: ({ cell }) => {
            return (
              <>
                <span>{`${MONEY_ROUND(cell.row.original.cotd_itbms === "" ? "0.00" : cell.row.original.cotd_itbms)}`}</span>
                {cell.row.original.art_itbm_venta === "0.00" ? <span className="porcent-label-exento">{"Ex"}</span> : <span className="porcent-label">{(Number(cell.row.original.art_itbm_venta) * 100).toFixed(0) + "%"}</span>}
              </>
            );
          },
        },
        {
          accessorFn: (row) => `${MONEY_ROUND(row.cotd_total)}`,
          accessorKey: "cotd_total",
          header: "TOTAL",
          size: 60,
          minSize: 60,
          muiTableBodyCellProps: {
            align: "center",
          },
          enableEditing: false,
          Edit: () => null,
        },
      ];
}

export function COLUMNS_LISTA_CREDITOS() {
  return window.innerWidth <= 611
    ? [
        {
          header: "CLIENTES",
          accessorFn: (row) => `${row.cli_nombre} ${row.cli_ruc} ${row.crd_monto_c} ${row.crp_monto_p} `,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b>{highlightText(row.original.cli_nombre, search)}</b>
                  </span>
                  <br></br>
                  <span>RUC : {highlightText(row.original.cli_ruc, search)}</span>
                  <br></br>
                  <span>TOTAL : {highlightText(Number(row.original.crd_monto_c).toFixed(2), search)}</span>
                  <br></br>
                  <span>SALDO ADEUDADO : {`${(Number(row.original.crd_monto_c) - Number(row.original.crp_monto_p)).toFixed(2)}`}</span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "cli_nombre",
          accessorFn: (row) => `${row.cli_ruc !== "" ? row.cli_nombre + " " + row.cli_ruc : row.cli_nombre}`,
          header: "NOMBRE",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
        },
        {
          accessorKey: "cli_ruc",
          accessorFn: (row) => `${row.cli_dv !== "" ? row.cli_ruc + " DV " + row.cli_dv : row.cli_ruc}`,
          header: "RUC",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "crd_monto_c",
          accessorFn: (row) => `${Number(row.crd_monto_c).toFixed(2)}`,
          header: "TOTAL",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "crp_monto_p",
          accessorFn: (row) => `${(Number(row.crd_monto_c) - Number(row.crp_monto_p)).toFixed(2)}`,
          header: "SALDO ADEUDADO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];
}

export function COLUMNS_CREDITOS_PAGO() {
  return [
    {
      accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.crp_fecha))}`,
      accessorKey: "crp_fecha",
      header: "FECHA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "fac_id",
      header: "N° FACTURA",
      accessorFn: (row) => `${row.fac_id.toString().padStart(10, "0")}`,
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "cli_nombre",
      header: "CLIENTE",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "cli_ruc",
      header: "RUC",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "crp_monto",
      header: "MONTO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.crp_fecha_delete))}`,
      accessorKey: "crp_fecha_delete",
      header: "ELIMINADO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}

export function COLUMNS_CREDITOS() {
  return [
    {
      accessorKey: "fac_id",
      header: "N° FACTURA",
      accessorFn: (row) => `${row.fac_id.toString().padStart(10, "0")}`,
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "cli_nombre",
      header: "CLIENTE",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "cli_ruc",
      header: "RUC",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "crd_monto",
      header: "MONTO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.crd_fecha))}`,
      accessorKey: "crd_fecha",
      header: "FECHA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}

export function COLUMNS_LISTA_CREDITOS_PAGO() {
  return window.innerWidth <= 611
    ? [
        {
          header: "ABONOS",
          accessorFn: (row) => `${row.crp_id} ${row.crp_monto} ${row.crp_fecha}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b>N° RECIBO: {highlightText(row.original.crp_id.toString().padStart(10, "0"), search)}</b>
                  </span>
                  <br></br>
                  <span>MONTO ABONADO : {highlightText(FORMATO_AM_PM(new Date(row.original.crp_monto)), search)} </span>
                  <br></br>
                  <span>FECHA : {highlightText(FORMATO_AM_PM(new Date(row.original.crp_fecha)), search)}</span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "crp_id",
          header: "N° RECIBO",
          accessorFn: (row) => `${row.crp_id.toString().padStart(10, "0")}`,
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "crp_monto",
          header: "MONTO ABONADO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.crp_fecha))}`,
          accessorKey: "crp_fecha",
          header: "FECHA",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];
}

export function COLUMNS_LISTA_CREDITOS_DETALLE(printFac) {
  return window.innerWidth <= 611
    ? [
        {
          header: "N° FACTURA",
          accessorFn: (row) => `${row.fac_id} ${row.fac_fecha} ${row.crd_monto_c} ${row.crp_monto_p} ${row.crp_monto_s}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b>N° FACTURA: {highlightText(row.original.fac_id.toString().padStart(10, "0"), search)}</b>
                  </span>
                  <br></br>
                  <span>FECHA : {highlightText(FORMATO_AM_PM(new Date(row.original.fac_fecha)), search)} </span>
                  <br></br>
                  <span>TOTAL : {highlightText(row.original.crd_monto_c, search)}</span>
                  <br></br>
                  <span>MONTO PAGADO : {highlightText(row.original.crp_monto_p, search)}</span>
                  <br></br>
                  <span>SALDO : {highlightText((Number(row.original.crd_monto_c) - Number(row.original.crp_monto_p)).toFixed(2), search)}</span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "fac_id",
          // accessorFn: (row) => `${row.fac_id.toString().padStart(10, "0")}`,
          header: "N° FACTURA",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
          Cell: ({ row, cell }) => {
            return (
              <Box className="d-flex">
                <MDBIcon
                  fas
                  icon="print"
                  className="me-3 class-btn-factura-datatable"
                  onClick={() =>
                    printFac({
                      data: row.original,
                      tipo: row.original.fac_recibo,
                      print_type: "recibo",
                    })
                  }
                />
                {row.original.fac_recibo === "1" ? <MDBIcon fas icon="file-pdf" className="me-3 class-btn-factura-datatable" onClick={() => printFac({ data: row.original, tipo: row.original.fac_recibo, print_type: "pdf" })} /> : null}
                <Label className="class-btn-factura">{row.original.fac_id.toString().padStart(10, "0")}</Label>
              </Box>
            );
          },
        },
        {
          accessorKey: "fac_fecha",
          accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.fac_fecha))}`,
          header: "FECHA FACTURA",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "crd_monto_c",
          header: "TOTAL",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "crp_monto_p",
          header: "MONTO PAGADO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorFn: (row) => `${(Number(row.crd_monto_c) - Number(row.crp_monto_p)).toFixed(2)}`,
          accessorKey: "crd_monto_s",
          header: "SALDO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];
}

export function COLUMNS_LISTA_ORDENES_NORMAL() {
  const { dataCompania } = useContext(StoreContext);
  return window.innerWidth <= 611
    ? [
        {
          header: "ORDENES",
          accessorFn: (row) => `${row.ord_identificador} ${row.usr_nombre} ${row.cli_nombre} ${row.ord_fecha} `,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    {dataCompania.com_lavanderia === "1" ? (
                      <>
                        <b># ORDEN: {highlightText(row.original.ord_number)}</b>
                      </>
                    ) : (
                      <># ORDEN: {highlightText(row.original.ord_identificador.substring(10, 14), search)}</>
                    )}
                  </span>
                  <br></br>
                  <span>CAJA : {highlightText(row.original.usr_nombre, search)}</span>
                  {dataCompania.com_lavanderia === "1" ? (
                    <>
                      <br></br>
                      <span>
                        CANTIDAD: {Number(row.original.ordd_cantidad_piezas ?? 0) > 0 && <>PIEZAS: {highlightText(Number(row.original.ordd_cantidad_piezas).toFixed(0), search)}</>}
                        {Number(row.original.ordd_cantidad_piezas ?? 0) > 0 && Number(row.original.ordd_cantidad_canasta ?? 0) > 0 && " | "}
                        {Number(row.original.ordd_cantidad_canasta ?? 0) > 0 && <>CANASTAS: {highlightText(Number(row.original.ordd_cantidad_canasta).toFixed(0), search)}</>}
                      </span>
                    </>
                  ) : null}
                  <br></br>
                  <span>CLIENTE : {highlightText(row.original.cli_nombre, search)}</span>
                  <br></br>
                  <span>FECHA : {highlightText(row.original.ord_fecha !== "0000-00-00 00:00:00" ? highlightText(FORMATO_AM_PM(new Date(row.original.ord_fecha)), search) : "")} </span>
                  <br></br>
                  <span className="float-end label-money">
                    <b> TOTAL : {MONEY_ROUND(Number(row.ordd_total_piezas ?? 0) + Number(row.ordd_total_canasta ?? 0))}</b>
                  </span>{" "}
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "ord_identificador",
          accessorFn: (row) => `${dataCompania.com_lavanderia === "1" ? row.ord_number : row.ord_identificador.substring(10, 14)}`,
          header: "# ORDEN",
          size: 100,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "ordd_cantidad",
          accessorFn: (row) =>
            `${Number(row.ordd_cantidad_piezas ?? 0) > 0 ? `PIEZAS: ${Number(row.ordd_cantidad_piezas).toFixed(0)}` : ""}${Number(row.ordd_cantidad_piezas ?? 0) > 0 && Number(row.ordd_cantidad_canasta ?? 0) > 0 ? " | " : ""}${
              Number(row.ordd_cantidad_canasta ?? 0) > 0 ? `CANASTAS: ${Number(row.ordd_cantidad_canasta).toFixed(0)}` : ""
            }`,
          header: "CANTIDAD",
          size: 100,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "usr_nombre",
          header: "CAJA",
          size: 100,
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "cli_nombre",
          header: "CLIENTE",
          accessorFn: (row) => `${row.ordd_facturado === "1" ? row.cli_nombre + " (FACTURADO)" : row.cli_nombre}`,

          // size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
        },
        {
          accessorKey: "ord_fecha",
          accessorFn: (row) => `${row.ord_fecha !== "0000-00-00 00:00:00" ? FORMATO_AM_PM(new Date(row.ord_fecha)) : ""}`,
          header: "FECHA",
          size: 120,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "ord_fecha_procesado",
          accessorFn: (row) => `${row.ord_fecha_procesado !== "0000-00-00 00:00:00" ? FORMATO_AM_PM(new Date(row.ord_fecha_procesado)) : ""}`,
          header: "FECHA PROCESADO",
          size: 120,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "ordd_total",
          accessorFn: (row) => (dataCompania.com_lavanderia === "1" ? (Number(row.ordd_total_piezas ?? 0) + Number(row.ordd_total_canasta ?? 0)).toFixed(2) : Number(row.ordd_total).toFixed(2)),
          header: "TOTAL",
          size: 100,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];
}
export function COLUMNS_LISTA_ORDENES() {
  return [
    {
      accessorKey: "usr_nombre",
      header: "MESERO",
      enableGlobalFilter: true,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
    },
    {
      accessorKey: "ord_identificador",
      accessorFn: (row) => `${row.ord_identificador.substring(10, 14)}`,
      header: "# ORDEN",
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "res_nombre",
      header: "# MESA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "ord_fecha",
      accessorFn: (row) => `${row.ord_fecha !== "0000-00-00 00:00:00" ? FORMATO_AM_PM(new Date(row.ord_fecha)) : ""}`,
      header: "FECHA",
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "ordd_total",
      accessorFn: (row) => `${parseFloat(row.ordd_total).toFixed(2)}`,
      header: "TOTAL",
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}
export function COLUMNS_LISTA_COTIZACION() {
  return window.innerWidth <= 611
    ? [
        {
          header: "COTIZACIÓN",
          accessorFn: (row) => `${row.cot_id} ${row.cli_nombre} ${row.cot_fecha} ${row.cot_descripcion} `,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b>
                      # COTIZACIÓN {highlightText(row.original.cot_id.toString().padStart(10, "0"), search)} - {highlightText(row.original.cli_nombre, search)}
                    </b>
                  </span>
                  <br></br>
                  <span>DESCRIPCIÓN : {highlightText(row.original.cot_descripcion, search)}</span>
                  <br></br>
                  <span>CLIENTE : {highlightText(row.original.cli_nombre, search)}</span>
                  <br></br>
                  <span>FECHA : {highlightText(row.original.cot_fecha !== "00-00-0000" ? highlightText(row.original.cot_fecha, search) : "")} </span>
                  <br></br>
                  <span className="float-end label-money">
                    <b>
                      {" "}
                      TOTAL :{" $"}
                      {format_miles({ num: MONEY_ROUND(row.original.cotd_total) })}
                    </b>
                  </span>{" "}
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "cot_id",
          header: "# COTIZACIÓN",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "cli_nombre",
          accessorFn: (row) => `${row.cli_ruc !== "" ? row.cli_nombre + " " + row.cli_ruc : row.cli_nombre}`,
          header: "NOMBRE",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
        },

        {
          accessorKey: "cot_descripcion",
          header: "DESCRIPCIÓN",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "cot_fecha",
          header: "FECHA",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "cotd_total",
          accessorFn: (row) => `$ ${MONEY_ROUND(row.cotd_total)}`,
          header: "TOTAL",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];
}
export function COLUMNS_EXISTENCIA_INVENTARIO() {
  return [
    {
      accessorKey: "art_upc",
      header: "CÓDIGO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "art_descripcion",
      header: "ARTÍCULO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "art_categoria",
      header: "CATEGORIA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "art_marca",
      header: "MARCA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "inv_qty",
      header: "CANTIDAD",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}
export function COLUMNS_LISTA_CLIENTE() {
  return window.innerWidth <= 611
    ? [
        {
          accessorFn: (row) => `${row.cli_ruc} ${row.cli_nombre} ${row.cli_telefono} ${row.cli_email} `,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            const nombre = row.original.cli_nombre || "";
            const ruc = row.original.cli_ruc || "";
            const dv = row.original.cli_dv || "";
            const telefono = row.original.cli_telefono || "";
            const email = row.original.cli_email || "";

            return (
              <Row className="m-0">
                <Col xs={12} className="p-0">
                  <div className="cli-card-cell">
                    <div className="cli-card-header">
                      <div className="cli-card-icon">
                        <MDBIcon fas icon="user" />
                      </div>

                      <div className="cli-card-main">
                        <span className="cli-card-label">Cliente</span>

                        <strong className="cli-card-name">{highlightText(nombre, search)}</strong>
                      </div>
                    </div>

                    <Row className="g-2 mt-2">
                      {ruc.length > 0 && (
                        <Col xs={12} sm={6}>
                          <div className="cli-card-meta">
                            <MDBIcon fas icon="id-card" />

                            <span>
                              {ruc.toLowerCase().includes("dv") ? (
                                highlightText(ruc, search)
                              ) : (
                                <>
                                  {highlightText(ruc, search)}
                                  {dv !== "" ? ` DV ${dv}` : ""}
                                </>
                              )}
                            </span>
                          </div>
                        </Col>
                      )}

                      {telefono.length > 0 && (
                        <Col xs={6} sm={3}>
                          <div className="cli-card-meta">
                            <MDBIcon fas icon="phone" />
                            <span>{highlightText(telefono, search)}</span>
                          </div>
                        </Col>
                      )}

                      {email.length > 0 && (
                        <Col xs={6} sm={3}>
                          <div className="cli-card-meta">
                            <MDBIcon fas icon="envelope" />
                            <span>{highlightText(email, search)}</span>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Col>
              </Row>
            );
          },
          accessorKey: "cli_nombre",
          header: "CLIENTE",
          grow: true,
          enableEditing: false,
        },
      ]
    : [
        {
          accessorKey: "cli_nombre",
          header: "NOMBRE",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableEditing: true,
        },
        {
          accessorKey: "cli_ruc",
          header: "RUC",
          accessorFn: (row) => `${row.cli_dv !== "" ? row.cli_ruc + " DV " + row.cli_dv : row.cli_ruc}`,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableEditing: true,
        },
        {
          accessorKey: "cli_telefono",
          header: "TELÉFONO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableEditing: true,
        },
        {
          accessorKey: "cli_email",
          header: "E-MAIL",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableEditing: true,
        },
      ];
}
export const COLUMNS_GAS_GASTOS =
  window.innerWidth <= 611
    ? [
        {
          Cell: ({ cell }) => {
            return (
              <Row className="text-left  d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b>
                      ID: {cell.row.original.gs_id} - {cell.row.original.tgs_desc}
                    </b>
                  </span>
                  <br></br>

                  <span>
                    Fecha : {cell.row.original.gs_fecha} <br></br> Sucursal : {cell.row.original.com_alias} <br></br> Descripción : {cell.row.original.gs_desc}
                  </span>
                  <br></br>
                  <span className="float-end label-money">
                    <b>MONTO : ${MONEY_ROUND(cell.row.original.gs_monto)}</b>
                  </span>
                </Col>
              </Row>
            );
          },
          accessorKey: "gs_id",
          header: "GASTOS",
          grow: true,
          enableEditing: false,
        },
      ]
    : [
        {
          accessorKey: "gs_id",
          header: "ID",
          size: 50,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "com_alias",
          header: "SUCURSAL",
          size: 100,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "gs_desc",
          header: "DESCRIPCIÓN",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
        },
        {
          accessorKey: "gs_monto", //normal accessorKey
          header: "MONTO",
          size: 60,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "tgs_desc", //normal accessorKey
          header: "TIPO DE GASTO",
          size: 100,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "gs_fecha", //normal accessorKey
          header: "FECHA",
          size: 60,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];

export const COLUMNS_TRAZABILIDAD =
  window.innerWidth <= 611
    ? [
        {
          header: "ARTÍCULO",

          accessorFn: (row) => `${row.art_upc} ${row.art_categoria} ${row.art_descripcion} ${row.art_marca} ${row.art_linea_roja} ${row.inv_qty}`,

          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            const data = row.original;

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  {/* CÓDIGO */}
                  <div className="mb-1">
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#36304a",
                      }}
                    >
                      {highlightText(data.art_upc, search)}
                    </span>
                  </div>

                  {/* DESCRIPCIÓN */}
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#222",
                      marginBottom: "5px",
                    }}
                  >
                    {highlightText(data.art_descripcion, search)}
                  </div>

                  {/* CATEGORÍA */}
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6c757d",
                      marginBottom: "2px",
                    }}
                  >
                    <b>CATEGORÍA:</b> {highlightText(data.art_categoria, search)}
                  </div>

                  {/* MARCA */}
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6c757d",
                      marginBottom: "8px",
                    }}
                  >
                    <b>MARCA:</b> {highlightText(data.art_marca, search)}
                  </div>

                  {/* LÍNEA ROJA + EXISTENCIA */}
                  <Row className="g-2">
                    <Col xs={6}>
                      <div
                        style={{
                          background: "#fff3cd",
                          border: "1px solid #ffe69c",
                          borderRadius: "8px",
                          padding: "5px 7px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "9px",
                            color: "#856404",
                            fontWeight: "700",
                          }}
                        >
                          LÍNEA ROJA
                        </div>

                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "700",
                            color: "#664d03",
                          }}
                        >
                          {highlightText(Number(data.art_linea_roja || 0).toFixed(2), search)}
                        </div>
                      </div>
                    </Col>

                    <Col xs={6}>
                      <div
                        style={{
                          background: "#edf8f1",
                          border: "1px solid #cfe9d7",
                          borderRadius: "8px",
                          padding: "5px 7px",
                          textAlign: "right",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "9px",
                            color: "#198754",
                            fontWeight: "700",
                          }}
                        >
                          EXISTENCIA
                        </div>

                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "700",
                            color: "#198754",
                          }}
                        >
                          {highlightText(new Decimal(data.inv_qty || 0).toFixed(2), search)}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            );
          },

          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "art_upc",
          header: "CÓDIGO",
        },
        {
          accessorKey: "art_descripcion", //normal accessorKey
          header: "DESCRIPCIÓN",
        },
        {
          accessorKey: "art_categoria", //normal accessorKey
          header: "CATEGORIA",
        },
        {
          accessorKey: "art_marca", //normal accessorKey
          header: "MARCA",
          //  size: 100,
        },
        {
          accessorKey: "art_linea_roja", //normal accessorKey
          header: "LÍNEA ROJA",
          //  size: 100,
          grow: false,
        },
        {
          accessorKey: "inv_qty", //normal accessorKey
          header: "EXISTENCIA",
          //  size: 100,
          grow: false,
        },
      ];
export const COLUMNS_MOV_MOVIMIENTO = [
  {
    accessorKey: "mov_id",
    header: "# MOVIMIENTO",
    size: 60,
  },
  {
    accessorKey: "mov_descripcion", //normal accessorKey
    header: "DESCRIPCIÓN",
  },
  {
    accessorKey: "bod_desde", //normal accessorKey
    header: "BODEGA INICIO",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorKey: "bod_hacia", //normal accessorKey
    header: "BODEGA FINAL",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorFn: (row) => `${row.mov_fecha !== "0000-00-00 00:00:00" ? moment(row.mov_fecha).format("YYYY-MM-DD") : ""}`,
    accessorKey: "mov_fecha", //normal accessorKey
    header: "FECHA",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 40,
    minSize: 60,
  },
  {
    accessorFn: (row) => `${row.mov_fecha_procesado !== "0000-00-00 00:00:00" ? moment(row.mov_fecha_procesado).format("YYYY-MM-DD") : ""}`,
    accessorKey: "mov_fecha_procesado", //normal accessorKey
    header: "F. PROCESADO",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 40,
    minSize: 60,
  },
];
export const COLUMNS_ENTRADA_INVENTARIO =
  window.innerWidth <= 611
    ? [
        {
          header: "ENTRADA POR INVENTARIO",
          accessorFn: (row) => `${row.re_id} ${row.com_alias} ${row.bod_nombre} ${row.re_fecha} ${row.re_fecha_procesado} ${row.art_upc} ${row.art_descripcion} ${row.red_cantidad}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b># INVENTARIO {highlightText(row.original.re_id, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">SUCURSAL: {highlightText(row.original.com_alias, search)}</span>
                  <br></br>
                  <span className="font-w-14">BODEGA: {highlightText(row.original.bod_nombre, search)}</span>
                  <br></br>
                  <span className="font-w-14">F. INVENTARIO: {highlightText(row.original.re_fecha !== "0000-00-00 00:00:00" ? moment(row.original.re_fecha).format("YYYY-MM-DD") : "", search)}</span>
                  <br></br>
                  <span className="font-w-14">F. PROCESADO:{highlightText(row.original.re_procesado === "1" ? highlightText(FORMATO_AM_PM(new Date(row.original.re_fecha_procesado)), search) : "", search)}</span>
                  <br></br>
                  <span className="font-w-14 float-end label-money">
                    <b>CANTIDAD: {highlightText(row.original.red_cantidad, search)}</b>
                  </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "re_id",
          header: "# INVENTARIO",
          size: 80,
        },
        {
          accessorKey: "com_alias", //normal accessorKey
          header: "SUCURSAL",
          size: 150,
        },
        {
          accessorKey: "bod_nombre", //normal accessorKey
          header: "BODEGA",
          size: 150,
        },
        {
          accessorKey: "re_fecha", //normal accessorKey
          header: "F. INVENTARIO",
          size: 150,
        },
        {
          accessorKey: "re_fecha_procesado", //normal accessorKey
          accessorFn: (row) => `${row.re_fecha_procesado !== "0000-00-00 00:00:00" ? moment(row.re_fecha_procesado).format("YYYY-MM-DD") : ""}`,
          header: "F. PROCESADO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
        {
          accessorKey: "art_upc", //normal accessorKey
          header: "CÓDIGO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
        {
          accessorKey: "red_cantidad", //normal accessorKey
          header: "CANTIDAD",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
      ];
export const COLUMNS_ENTRADA_FACTURA_COMPRA =
  window.innerWidth <= 611
    ? [
        {
          header: "ENTRADA POR FACTURA DE COMPRA",
          accessorFn: (row) => `${row.dc_docn} ${row.com_alias} ${row.bod_nombre} ${row.dc_fecha} ${row.dc_fecha_procesado} ${row.art_upc} ${row.art_descripcion} ${row.dcd_cantidad}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b># DOCUMENTO {highlightText(row.original.dc_docn, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">SUCURSAL: {highlightText(row.original.com_alias, search)}</span>
                  <br></br>
                  <span className="font-w-14">BODEGA: {highlightText(row.original.bod_nombre, search)}</span>
                  <br></br>
                  <span className="font-w-14">F. DOCUMENTO:{highlightText(row.original.dc_fecha !== "0000-00-00 00:00:00" ? moment(row.original.dc_fecha).format("YYYY-MM-DD") : "", search)}</span>
                  <br></br>
                  <span className="font-w-14">F. PROCESADO: {highlightText(row.original.dc_fecha_procesado !== "0000-00-00 00:00:00" || row.original.dc_fecha_procesado !== null ? highlightText(FORMATO_AM_PM(new Date(row.original.dc_fecha_procesado)), search) : "", search)}</span>
                  <br></br>
                  <span className="font-w-14 float-end label-money">
                    <b> CANTIDAD: {highlightText(row.original.dcd_cantidad, search)}</b>
                  </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "dc_docn",
          header: "# DOCUMENTO",
          size: 80,
        },
        {
          accessorKey: "com_alias", //normal accessorKey
          header: "SUCURSAL",
          size: 150,
        },
        {
          accessorKey: "bod_nombre", //normal accessorKey
          header: "BODEGA",
          size: 150,
        },
        {
          accessorKey: "dc_fecha", //normal accessorKey
          header: "F. FACTURA DE COMPRA",
          size: 150,
        },
        {
          accessorKey: "re_fecha_procesado", //normal accessorKey
          accessorFn: (row) => `${row.dc_fecha_procesado === "0000-00-00 00:00:00" || row.dc_fecha_procesado === null ? "" : moment(row.dc_fecha_procesado).format("YYYY-MM-DD")}`,
          header: "F. PROCESADO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
        {
          accessorKey: "art_upc", //normal accessorKey
          header: "CÓDIGO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
        {
          accessorKey: "art_referencia", //normal accessorKey
          header: "REFERENCIA",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
        {
          accessorKey: "dcd_cantidad", //normal accessorKey
          header: "CANTIDAD",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
      ];
export const COLUMNS_SALIDA_VENTA =
  window.innerWidth <= 611
    ? [
        {
          header: "SALIDA POR VENTA",
          accessorFn: (row) => `${row.fac_id} ${row.com_alias} ${row.fac_fecha} ${row.usr_nombre} ${row.fcd_cantidad}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b># FACTURA {highlightText(row.original.fac_id, search)}</b>
                  </span>
                  <br />
                  <span className="font-w-14">SUCURSAL: {highlightText(row.original.com_alias, search)}</span>
                  <br></br>
                  <span className="font-w-14">FECHA: {highlightText(row.original.fac_fecha !== "0000-00-00 00:00:00" ? moment(row.original.fac_fecha).format("YYYY-MM-DD") : "", search)}</span>
                  <br></br>
                  <span className="font-w-14">VENDEDOR: {highlightText(row.original.usr_nombre, search)}</span>
                  <br></br>
                  <span className="font-w-14 float-end label-money">
                    <b>CANTIDAD: {highlightText(new Decimal(row.original.fcd_cantidad).toFixed(2), search)}</b>
                  </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "fac_id",
          header: "# FACTURA",
          size: 80,
        },
        {
          accessorKey: "com_alias", //normal accessorKey
          header: "SUCURSAL",
          size: 150,
        },
        {
          accessorKey: "fac_fecha", //normal accessorKey
          accessorFn: (row) => `${row.fac_fecha !== "0000-00-00 00:00:00" ? moment(row.fac_fecha).format("YYYY-MM-DD") : ""}`,
          header: "FECHA",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
        {
          accessorKey: "usr_nombre", //normal accessorKey
          header: "VENDEDOR",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
        {
          accessorKey: "fcd_cantidad", //normal accessorKey
          header: "CANTIDAD",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
      ];

export const COLUMNS_RE_CUENTO =
  window.innerWidth <= 611
    ? [
        {
          header: "INVENTARIO",

          accessorFn: (row) =>
            `${row.re_id || ""} 
       ${row.re_descripcion || ""} 
       ${row.com_alias || ""} 
       ${row.bod_nombre || ""} 
       ${row.usr_nombre || ""} 
       ${row.re_fecha || ""} 
       ${row.re_fecha_procesado || ""}`,

          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            const data = row.original;

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  {/* INVENTARIO */}
                  <div className="mb-1">
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#36304a",
                      }}
                    >
                      # INVENTARIO {highlightText(data.re_id || "", search)}
                    </span>
                  </div>

                  {/* DESCRIPCIÓN */}
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#222",
                      marginBottom: "7px",
                    }}
                  >
                    {highlightText(data.re_descripcion || "", search)}
                  </div>

                  {/* SUCURSAL */}
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6c757d",
                      marginBottom: "2px",
                    }}
                  >
                    <b>SUCURSAL:</b> {highlightText(data.com_alias || "", search)}
                  </div>

                  {/* BODEGA */}
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6c757d",
                      marginBottom: "2px",
                    }}
                  >
                    <b>BODEGA:</b> {highlightText(data.bod_nombre || "", search)}
                  </div>

                  {/* USUARIO */}
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6c757d",
                      marginBottom: "8px",
                    }}
                  >
                    <b>USUARIO:</b> {highlightText(data.usr_nombre || "", search)}
                  </div>

                  {/* FECHAS */}
                  <Row className="g-2">
                    <Col xs={6}>
                      <div
                        style={{
                          background: "#f7f8fb",
                          border: "1px solid #e5e9f0",
                          borderRadius: "8px",
                          padding: "5px 7px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "9px",
                            color: "#7b8492",
                            fontWeight: "700",
                          }}
                        >
                          FECHA
                        </div>

                        <div
                          style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            color: "#36304a",
                          }}
                        >
                          {highlightText(data.re_fecha || "", search)}
                        </div>
                      </div>
                    </Col>

                    <Col xs={6}>
                      <div
                        style={{
                          background: data.re_procesado === "1" ? "#edf8f1" : "#f7f8fb",

                          border: data.re_procesado === "1" ? "1px solid #cfe9d7" : "1px solid #e5e9f0",

                          borderRadius: "8px",
                          padding: "5px 7px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "9px",
                            color: data.re_procesado === "1" ? "#198754" : "#7b8492",
                            fontWeight: "700",
                          }}
                        >
                          PROCESADO
                        </div>

                        <div
                          style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            color: data.re_procesado === "1" ? "#198754" : "#6c757d",
                          }}
                        >
                          {data.re_procesado === "0" ? "PENDIENTE" : highlightText(data.re_fecha_procesado || "", search)}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            );
          },

          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "re_id",
          header: "# INVENTARIO",
          size: 80,
        },
        {
          accessorKey: "re_descripcion", //normal accessorKey
          header: "DESCRIPCIÓN",
          size: 150,
        },
        {
          accessorKey: "com_alias", //normal accessorKey
          header: "SUCURSAL",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
        {
          accessorKey: "usr_nombre", //normal accessorKey
          header: "USUARIO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
        {
          accessorKey: "bod_nombre", //normal accessorKey
          header: "BODEGA",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
        {
          accessorKey: "re_fecha", //normal accessorKey
          accessorFn: (row) => `${row.re_fecha !== "0000-00-00 00:00:00" ? moment(row.re_fecha).format("YYYY-MM-DD") : ""}`,
          header: "FECHA",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
        {
          accessorFn: (row) => `${row.re_procesado === "1" ? FORMATO_AM_PM(new Date(row.re_fecha_procesado)) : ""}`,
          accessorKey: "re_fecha_procesado", //normal accessorKey
          header: "FECHA PROCESADO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
      ];
export function COLUMNS_RE_RECUENTO_DETALLE() {
  return window.innerWidth <= 611
    ? [
        {
          header: "ARTÍCULO",

          accessorFn: (row) =>
            `${row.art_upc || ""} 
       ${row.art_referencia || ""} 
       ${row.art_descripcion || ""} 
       ${row.mar_descripcion || ""} 
       ${row.art_serie || ""}`,

          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            const data = row.original;

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  {/* UPC */}
                  <div className="mb-1">
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#36304a",
                      }}
                    >
                      {highlightText(data.art_upc || "", search)}
                    </span>
                  </div>

                  {/* DESCRIPCIÓN */}
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#222",
                      marginBottom: "6px",
                    }}
                  >
                    {highlightText(data.art_descripcion || "", search)}
                  </div>

                  {/* REFERENCIA */}
                  {data.art_referencia && (
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#6c757d",
                        marginBottom: "2px",
                      }}
                    >
                      <b>REFERENCIA:</b> {highlightText(data.art_referencia || "", search)}
                    </div>
                  )}

                  {/* MARCA */}
                  {data.mar_descripcion && (
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#6c757d",
                        marginBottom: "2px",
                      }}
                    >
                      <b>MARCA:</b> {highlightText(data.mar_descripcion || "", search)}
                    </div>
                  )}

                  {/* SERIE */}
                  {data.art_serie && (
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#6c757d",
                      }}
                    >
                      <b>SERIE:</b> {highlightText(data.art_serie || "", search)}
                    </div>
                  )}
                </Col>
              </Row>
            );
          },

          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },

        /* CONTEO EDITABLE */
        {
          header: "CONTEO",
          accessorKey: "red_cantidad",
          enableEditing: true,

          size: 95,
          minSize: 95,
          maxSize: 95,

          muiTableHeadCellProps: {
            align: "center",
          },

          muiTableBodyCellProps: {
            align: "center",
          },

          muiEditTextFieldProps: {
            type: "number",
            inputProps: {
              step: "0.01",
            },
          },

          Cell: ({ cell }) => (
            <div
              style={{
                background: "#f1eff7",
                border: "1px solid #ddd8ea",
                borderRadius: "8px",
                padding: "5px 7px",
                textAlign: "center",
                color: "#36304a",
                fontWeight: "700",
                fontSize: "13px",
              }}
            >
              {new Decimal(cell.getValue() || 0).toFixed(2)}
            </div>
          ),
        },
      ]
    : [
        {
          accessorKey: "art_upc", //access nested data with dot notation
          header: "CÓDIGO",
          size: 120,
          minSize: 100,
          enableEditing: false,
        },
        {
          accessorKey: "art_descripcion",
          header: "DESCRIPCIÓN",
          // size: 250,
          // minSize: 200,
          enableEditing: false,
        },
        {
          accessorKey: "art_serie",
          header: "SERIE",
          size: 100,
          minSize: 100,
          enableEditing: true,
        },
        {
          Cell: ({ cell }) => {
            return (
              <Row>
                <Col xs={12} className="text-center">
                  <span>{`${new Decimal(cell.row.original.red_cantidad).toFixed(2)}`}</span>
                </Col>
              </Row>
            );
          },
          accessorKey: "red_cantidad",
          header: "CANTIDAD",
          size: 40,
          minSize: 40,
        },
      ];
}
export function COLUMNS_MOVD_MOVIMIENTO_DETALLE() {
  return [
    {
      accessorKey: "art_upc", //access nested data with dot notation
      header: "CÓDIGO",
      size: 120,
      minSize: 100,
      enableEditing: false,
    },
    {
      accessorKey: "art_descripcion",
      header: "DESCRIPCIÓN",
      size: 230,
      minSize: 200,
      enableEditing: false,
    },
    {
      accessorKey: "art_serie",
      header: "SERE",
      size: 80,
      minSize: 60,
      enableEditing: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "inv_qty",
      header: "EXISTENCIA EN BODEGA",
      size: 80,
      minSize: 60,
      enableEditing: false,
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${new Decimal(cell.row.original.inv_qty).toFixed(2)}`}</span>
            </Col>
          </Row>
        );
      },
    },
    {
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${new Decimal(cell.row.original.movd_cantidad).toFixed(2)}`}</span>
            </Col>
          </Row>
        );
      },
      accessorKey: "movd_cantidad",
      header: "CANTIDAD A MOVER",
      size: 40,
      minSize: 40,
    },
  ];
}
